<template>
  <div 
      :style="`
              --addBtnColor: ${colors.addBtnColor};
              --addBtnColorInv: ${colors.addBtnColorInv}; 
              --iconsColor1: ${colors.iconsColor1}; 
              --iconsColor2: ${colors.iconsColor2}; 
              --secundar: ${colors.secundarColor}; 
              --principal: ${colors.principalColor}; 
              --sideBarBg: ${colors.sideBarBg}; 
              --mainPageBg: ${colors.mainPageBg}; 
              --white: ${whiteColor};
            `"
      :class="[
        'order_view', 
        (json.type != 'Kiosk') ? 'mobile' : 'kiosk',
        'comp_' + json.company_id
      ]"
    >
    <div :class="(loader) ? 'loader' : 'loader none'">
      <div class="el-loading-spinner">
        <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
      </div>
    </div>

    <!-- Overlay de asteptare dupa deschiderea aplicatiei Viva (plata cu cardul pe dispozitiv).
         Ramane pana vine raspuns de la Viva sau pana expira timeout-ul de siguranta (1 min).
         Dupa 10s apare butonul "Reincearca", care re-trimite DOAR intentul, nu si alte requesturi. -->
    <div class="vivaWaiting" v-if="withVivaWallet && vivaInProgress">
      <div class="vivaWaiting__box">
        <div class="vivaWaiting__spinner">
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
        </div>
        <p class="vivaWaiting__text">{{$t('addOrder.vivaWaitingText')}}</p>
        <div class="vivaWaiting__actions" v-if="showVivaRetry">
          <button
            class="vivaWaiting__retry"
            @click="retryVivaIntent()"
          >{{$t('addOrder.vivaRetryButton')}}</button>
          <button
            class="vivaWaiting__cancel"
            @click="cancelVivaFromOverlay()"
          >{{$t('addOrder.vivaCancelButton')}}</button>
        </div>
      </div>
    </div>

    <!-- <div class="callWaiter">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="0" height="0">
        <defs>
          <filter id="goo">
            <feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur" />
            <feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="goo" />
            <feBlend in="SourceGraphic" in2="goo" />
          </filter>
        </defs>
      </svg>
      <div class="callWaiter__group">
        <div :class="['callWaiter__buttons', waiterStep0 ? 'step-0' : '', waiterStep1 ? 'step-1' : '', waiterStep2 ? 'step-2' : '' ]">
          <div class="callWaiter__social-btn-2 callWaiter__social-btn" @click="callWaiter(1)">Nota</div>
          <div class="callWaiter__social-btn-1 callWaiter__social-btn" @click="confirmCallWaiter()">Alceva</div>
          <div class="callWaiter__open-btn" @click="waiterSteps()"><span>Cheama chelnerul</span></div>
        </div>
      </div>
    </div> -->

    <div v-if="!consultativeQrMenu && (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk ' && json.type == 'mobile'" class="fastTip">
      <button v-if="(cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips)" @click="addOrRemoveTip(1, true)">+ Tips / Bacșiș</button>
    </div>
    <!-- <div v-if="!error && banners && banners.length"
      :class="(banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'banner bannerHidden' : 'banner'" 
      >
      <swiper
        :modules="swiperModule"
        effect="fade"
        v-if="banners && banners.length"
        scrollbar
        :loop="true"
        :grabCursor="false"
        :centeredSlides="true"
        :autoplay="{
          delay: 5000,
          disableOnInteraction: false,
          waitForTransition: false
        }"
        class="special-offer-block focus-in"
       >
        <swiper-slide
          v-for="(slider, index) in banners"
          :key="index + 'slider'">
          <a @click="redirectFromImage(slider)">
            <div class="banner_img" 
                  :style="'background-image: URL('+slider.image_banner+');'" 
                  :alt="'Special Offer' + index"></div>
          </a>
        </swiper-slide>
      </swiper>
    </div> -->

    
    <!-- <div :class="[
        'orderspos',
        (banners && banners.length && activeProductList.top && json.type != 'Kiosk') ? 'bannerHidden' : (banners && banners.length) ? 'withBanner' : 'noBanner',
        (cart && cart.myCart && cart.myCart.products_count > 0) ? 'noToolbar' : 'noToolbar',
        (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips) && json.type != 'Kiosk' && json.type == 'mobile' ? 'withFastTip' : 'noFastTip'
      ]" v-if="!error"> -->
      <div :class="[
        'orderspos',
        'noBanner',  // Adaugăm noBanner constant
        (cart && cart.myCart && cart.myCart.products_count > 0) ? 'noToolbar' : 'noToolbar',
        (cart && cart.myCart && cart.myCart.products_count == 0 && cart.use_tips && json.type != 'Kiosk' && json.type == 'mobile') ? 'withFastTip' : 'noFastTip'
      ]" v-if="!error">


      <div class="productList_wrapper">
      
        <div :class="['topBar', consultativeQrMenu ? 'consultativeMenuBar' : '']">
          <div class="backButton" @click="openShowSplashScreenModal()">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.menuNavbar')}}
          </div>
          <div class="search" @click="toggleSearchBar">
            <img src="../../public/search.png">
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
          <div v-if="!consultativeQrMenu" class="cart" @click="showCart()">
            <img src="../../public/cart2.png">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        
        <div :class="[
          (this.json.type != 'Kiosk' && top_category && top_category.length && selectedTopCategory && top_category.filter(el => el.id == selectedTopCategory)  && top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
          'productList_wrapper_left',
            isSearchBarVisible ? 'showSearch' : ''
        ]">
          <div class="search_topBar" v-if="isSearchBarVisible">
            <div class="search_wrapper">
              <div class="filter__search showw">
                <div class="search">
                  <span class="icosearch">
                    <svg xmlns="http://www.w3.org/2000/svg" width="29.414" height="29.414" viewBox="0 0 29.414 29.414">
                      <g id="Icon_feather-search" data-name="Icon feather-search" transform="translate(-3.5 -3.5)">
                        <path id="Path_2498" data-name="Path 2498" d="M28.5,16.5a12,12,0,1,1-12-12A12,12,0,0,1,28.5,16.5Z" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        <path id="Path_2499" data-name="Path 2499" d="M31.5,31.5l-6.525-6.525" fill="none" stroke="inherit" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                      </g>
                    </svg>
                  </span>
                   <!-- @keyup.enter="newText()" -->
                  <div class="inputContainerSearch" style="width: 100%; position: relative;">
                    <input type="text" ref="searchText" :placeholder="$t('addOrder.search')" v-model="searchText" @keyup="handleKeyupSearch($event)">
                    <span :class="showRemoveTextFromSearch ? 'closeSearch show' : 'closeSearch' " @click="deleteTextFromSearchMobile()">
                      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                        <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                          c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                          c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                          c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                          l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                          c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                    </span>
                  </div>
                  <button @click="newText()">{{ $t('general.search') }}</button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="json.type != 'Kiosk' && json.company_id == 39" 
            :class="(listOfLangIsOpen) ? 'lang_btn open' : 'lang_btn' "
            style="position: absolute; right: 10px; top: 10px; z-index: 1;"
          >
            <a @click.prevent="openListOfLang()">
              <img :src="'../' + curentLang + '.png'" alt="lang">
            </a>
            <div class="listOfLang">
              <template v-for="lng in allLang" :key="lng">
                <a @click.prevent="changeLanguageLocal(lng)" v-if="lng != curentLang">
                  <img :src="'../' + lng + '.png'" alt="lng">
                </a>
              </template>
            </div>
          </div>
          <div class="filter">
            <div :class="['filter__bar',
            ]">
              <div class="filter__cat">
                <template v-for="top in top_category" :key="top.id">
                  <div :class="[
                        ((top.id == selectedTopCategory && this.json.type == 'Kiosk') ? 'topGroup active' : 'topGroup'), 
                        top.id + ' ' //for scroolTopCategory() function
                        ]">
                    <a @click="getTop(top)" :class="(top.id == selectedTopCategory) ? 'selected ' + top.id : '' + top.id ">
                        <p>{{getTopCategoryName(top)}}</p>
                        <div class="cat_photo" :style="'background-image: url('+top.image+');'" ></div>
                    </a>
                    <div class="childs" v-if="this.json.type == 'Kiosk'">
                      <template v-for="cat in top.categories" :key="cat.id">
                        <a @click="getProducts(cat.id, top.id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                          <p>{{getCategoryName(cat)}}</p>
                          <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                        </a>
                      </template>
                    </div>
                  </div>
                </template>
                <template v-for="cat in category" :key="cat.id">
                  <a @click="getProducts(cat.id, null)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                    <p>{{getCategoryName(cat)}}</p>
                    <div class="cat_photo" :style="'background-image: url('+cat.image+');'" ></div>
                  </a>
                </template>
              </div>
            </div>
          </div>
          <div class="filter filter2"  v-if="this.json.type != 'Kiosk' && top_category && top_category.length  && selectedTopCategory && this.top_category.filter(el => el.id == selectedTopCategory) && this.top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1">
            <div class="filter__bar">
              <div class="filter__cat">
                <template v-for="cat in this.top_category.filter(el => el.id == selectedTopCategory)[0].categories" :key="cat.id">
                  <a @click="getProducts(cat.id, this.top_category.filter(el => el.id == selectedTopCategory)[0].id)" :class="(cat.id == selectedCategory) ? 'selected ' + cat.id : '' + cat.id ">
                    <p>{{getCategoryName(cat)}}</p>
                  </a>
                </template>
              </div>
            </div>
          </div>
        </div>

        <div :class="[
            (this.json.type != 'Kiosk' && top_category && top_category.length && selectedTopCategory && this.top_category.filter(el => el.id == selectedTopCategory) && this.top_category.filter(el => el.id == selectedTopCategory)[0].categories.length > 1) ? 'with_filter2' : 'no_filter2',
            'productList_wrapper_right',
            isSearchBarVisible ? 'showSearch' : ''
          ]">
          
          <div :class="['productList__wrapper', isSearchBarVisible ? 'showSearch' : '']">
            <div class="productList" :style="(loading ? 'overflow: hidden;' : '')">
              <template v-if="!loading">
                <template v-if="products.length">
                  <template v-for="product in products" :key="product.id">
                    <div :class="[
                        'product',
                        product.is_highlight ? 'is_highlight' : '',
                        (productHasNoStock(product.id) || productIsIndisponible(product.id)) ? 'prodOutOfStock' : ''
                      ]" :ref="'product' + product.id" @click="openProduct(product)">
                      <template v-if="productHasNoStock(product.id)">
                        <div class="outOfStock"></div>
                        <span class="outOfStockTxt">{{$t('addOrder.outOfStock')}}</span>
                      </template>
                      <template v-else-if="productIsIndisponible(product.id)">
                        <div class="outOfStock"></div>
                        <span class="outOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                      </template>
                      <div class="product_img_title">
                        <div class="productImage__wrapper">
                          <template v-if="product.image_url">
                            <div 
                              class="productImage"
                              :style="{
                                  backgroundImage: 'url(' + encodeURI(product.image_url) + ')',
                                  backgroundSize: product.image_size ? product.image_size : ''
                              }">
                            </div>
                            <template v-if="json.company_id != 46">
                              <p class="discount_badge" v-if="productHasDiscount(product)">{{getProductDiscountPercent(product)}} %</p>
                              <p class="discount_badge" v-else-if="product.old_price > 0">{{Math.ceil(( product.old_price - getProductPrice(product) ) / product.old_price * 100)}} %</p>
                            </template>
                          </template>
                        </div>
                        <div class="prodTitle__wrapper">
                          <p class="prod_title">{{getProductName(product)}}</p>
                          <p class="prod_description" v-if="getProductDesc(product)">{{getProductDesc(product)}}</p>
                          <p class="prod_description" v-if="product.prod_info && product.prod_info != ''" v-html="product.prod_info"></p>
                        </div>

                        <div class="wrepperPrice">
                          <template v-if="product.use_price_to_show && product.price_to_show > 0">
                            <p v-if="!(json.company_id == 39 && product.price_details.price <= 0)" class="prod_price" v-html="product.price_to_show + ' ' + product.price_details.currency_symbol"></p>
                          </template>
                          <template v-else-if="productHasDiscount(product)">
                            <p class="old_prod_price" v-html="getProductUnitListPrice(product, true)"></p>
                            <p class="prod_price" v-html="getProductUnitDiscountedPrice(product, true)"></p>
                            <p @click.stop="addProductDirectlyToCart(product)" class="prod_addDirectToCart" v-if="json.company_id == 39">+</p>
                          </template>
                          <template v-else>
                            <p class="old_prod_price" v-if="product.old_price > 0" v-html="product.old_price + ' ' + product.price_details.currency_symbol"></p>
                            <p v-if="!(json.company_id == 39 && getProductPrice(product) <= 0) && getProductPrice(product) != '0'" class="prod_price" v-html="getProductPrice(product, true)"></p>
                          <p @click.stop="addProductDirectlyToCart(product)" class="prod_addDirectToCart" v-if="json.company_id == 39">+</p>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="no-products-found">{{ $t('addOrder.noProductsFound') }}</div>
                </template>
              </template>
              <div :class="(loading ? 'show-loader' : 'hide-loader')">
                <div class="el-loading-spinner">
                  <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle class="spinner_1KD7" cx="12" cy="3" r="0"/><circle class="spinner_1KD7 spinner_MJg4" cx="16.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_SeO7" cx="7.50" cy="4.21" r="0"/><circle class="spinner_1KD7 spinner_sj9X" cx="19.79" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_7he2" cx="4.21" cy="7.50" r="0"/><circle class="spinner_1KD7 spinner_WwCl" cx="21.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_4zOl" cx="3.00" cy="12.00" r="0"/><circle class="spinner_1KD7 spinner_vy2J" cx="19.79" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_kugV" cx="4.21" cy="16.50" r="0"/><circle class="spinner_1KD7 spinner_os1F" cx="16.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_WNEg" cx="7.50" cy="19.79" r="0"/><circle class="spinner_1KD7 spinner_l1Tw" cx="12" cy="21" r="0"/></svg>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="error error_page" v-if="error">
      <h1>
        <template v-if="errorType" class="jumping">
          {{$t('general.error_not_open_table_'+ errorType)}}
        </template>
        <template v-else>
          {{$t('general.error_not_open_table')}}
        </template>
      </h1>
    </div>

    <vue-final-modal
            name="productModal"
            v-model="showProductModal"
            :hideOverlay="true"
            :class="['productModal', showProductModal ? 'active' : '', consultativeQrMenu ? 'consultativeProductModal' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <div :class="['topBar', consultativeQrMenu ? 'consultativeDetailBar' : '']">
          <div class="backButton" @click="showProductModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.productNavbar')}}
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
          <div v-if="!consultativeQrMenu" class="cart" @click="showCart()">
            <img src="../../public/cart2.png">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        <div class="product">
          <template v-if="currentProductInPopup && currentProductInPopup.image_url && currentProductInPopup.image_url[0]['url']">
            <span style=""></span>
            <div 
              class="photo"
              :style="{
                backgroundImage: 'url(' + encodeURI(currentProductInPopup.image_url[0].url) + ')',
                backgroundSize: currentProductInPopup.image_size ? currentProductInPopup.image_size : ''
              }">
            </div>
          </template>
          <div class="prod_white" style="background: #F5F5F5; position: relative; z-index: 2;">
            <div class="productModal__product" v-if="currentProductInPopup">
              <div class="title__wraper">
                <div class="title">
                  <p>{{getProductName(currentProductInPopup)}}</p>
                </div>
                <div class="price">
                  <template v-if="currentProductInPopup.use_price_to_show && currentProductInPopup.price_to_show > 0">
                    <p v-html="currentProductInPopup.price_to_show + ' ' + currentProductInPopup.price_details.currency_symbol"></p>
                  </template>
                  <template v-else-if="productHasDiscount(currentProductInPopup)">
                    <p class="prod_discount_price">
                      <span class="old_prod_price" v-html="getProductUnitListPrice(currentProductInPopup, true)"></span>
                      <span class="prod_price" v-html="getProductUnitDiscountedPrice(currentProductInPopup, true)"></span>
                    </p>
                  </template>
                  <template v-else>
                    <p v-if="getProductUnitListPrice(currentProductInPopup)" v-html="getProductUnitListPrice(currentProductInPopup, true)"></p>
                  </template>
                </div>
                <div class="product_stock" v-if="getProductStock(currentProductInPopup.id) >= 1">
                  <span class="product_stock_available" v-if="getProductStock(currentProductInPopup.id) > 99">{{$t('addOrder.sufficientStock')}}</span>
                  <span class="product_stock_available" v-else>{{getProductStock(currentProductInPopup.id)}} {{$t('addOrder.available')}}</span>
                </div>
                <p class="lowest_price_note" v-if="productHasDiscount(currentProductInPopup) && currentProductInPopup.lowest_price_last_30_days != null">
                  {{$t('addOrder.lowestPriceLast30Days')}} {{currentProductInPopup.lowest_price_last_30_days}} {{currentProductInPopup.price_details.currency_symbol}}
                </p>
                <div>
                  <p>{{getProductDesc(currentProductInPopup, true)}}</p>
                  <p v-if="currentProductInPopup.prod_info && currentProductInPopup.prod_info != ''" v-html="currentProductInPopup.prod_info"></p>
                  <!-- <template v-if="currentProductInPopup.description && currentProductInPopup.description.length > 255">
                    <p>{{currentProductInPopup.description.substring(0, 255)}}...</p>
                  </template>
                  <template v-else>
                    <p>{{currentProductInPopup.description}}</p>
                  </template> -->
                </div>
              </div>
            </div>

            <div class="gray__prod_wrapper">
              <ProductOptionsTable
              v-if="!optionsInSteps && currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length"
              :currentProductInPopup="currentProductInPopup"
              :stocks-for-product-options="stocksForProductOptions"
              :product-options-cov-stock-map="productOptionsCovStockMap"
              @update-categories="updateCategories"
              ></ProductOptionsTable>

              <div class="other_info" v-if="currentProductInPopup && currentProductInPopup.other_info.length">
                  <div class="info" v-for="other_info in currentProductInPopup.other_info" :key="other_info.id" @click="(isExpended == other_info.id) ? isExpended = null : isExpended = other_info.id">
                    <h2>{{other_info.title}}</h2>
                    <div class="other_info_ico">
                      <svg :class="(isExpended != other_info.id) ? 'closed' : ''" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                          viewBox="0 0 460.775 460.775" style="enable-background:new 0 0 460.775 460.775;" xml:space="preserve">
                            <path d="M285.08,230.397L456.218,59.27c6.076-6.077,6.076-15.911,0-21.986L423.511,4.565c-2.913-2.911-6.866-4.55-10.992-4.55
                              c-4.127,0-8.08,1.639-10.993,4.55l-171.138,171.14L59.25,4.565c-2.913-2.911-6.866-4.55-10.993-4.55
                              c-4.126,0-8.08,1.639-10.992,4.55L4.558,37.284c-6.077,6.075-6.077,15.909,0,21.986l171.138,171.128L4.575,401.505
                              c-6.074,6.077-6.074,15.911,0,21.986l32.709,32.719c2.911,2.911,6.865,4.55,10.992,4.55c4.127,0,8.08-1.639,10.994-4.55
                              l171.117-171.12l171.118,171.12c2.913,2.911,6.866,4.55,10.993,4.55c4.128,0,8.081-1.639,10.992-4.55l32.709-32.719
                              c6.074-6.075,6.074-15.909,0-21.986L285.08,230.397z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g>
                      </svg>
                    </div>
                    <Collapse as="section" :when="isExpended == other_info.id" class="collapse_class">
                      <div class="description">
                        <p v-html="other_info.description"></p>
                      </div>
                    </Collapse>
                  </div>
              </div>

              <div class="info__wrapper" v-if="currentProductInPopup && currentProductInPopup.allow_user_comments">
                <textarea name="info" maxlength="255" :placeholder="$t('addOrder.infosup')" v-model="currentProductInPopup.additional_info"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="currentProductInPopup && !consultativeQrMenu">
        <div class="footer__quantity" v-if="!currentProductInPopup.limit_quantity_kiosk_qr">
          <button :disabled="currentProductInPopup.quantity <= 1" @click="updateQuantity(currentProductInPopup, 0)">-</button>
          <span>{{currentProductInPopup.quantity}}</span>
          <button @click="updateQuantity(currentProductInPopup, 1)">+</button>
        </div>
        <div class="footer__right">
          <div class="footer__addToCart">
            <template v-if="optionsInSteps">
              <button @click="nextOptionToCart(1,1)">
                {{$t('addOrder.next_to_option')}}
              </button>
            </template>
            <template v-else>
              <template v-if="currentProductInPopup.in_edit">
                <button :disabled="addToCartDisabled" @click="editToCart()">
                {{$t('addOrder.edit')}}</button>
              </template>
              <template v-else>
                <button :disabled="addToCartDisabled" @click="addToCart()">
                  {{$t(optionsInSteps ? 'addOrder.add' : 'addOrder.addFor')}}
                  <template v-if="!optionsInSteps">
                    <span v-html="' ' + getProductCartTotalPrice(currentProductInPopup, true)"></span>
                  </template>
                </button>
              </template>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="optionModal"
            v-model="showOptionModal"
            :hideOverlay="true"
            :class="['optionModal', showOptionModal ? 'active' : '', consultativeQrMenu ? 'consultativeOptionModal' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <div :class="['topBar', consultativeQrMenu ? 'consultativeDetailBar' : '']">
          <div class="backButton" @click="nextOptionToCart(-1)">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.optionNavar')}}
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
          <div v-if="!consultativeQrMenu" class="cart" @click="showCart()">
            <img src="../../public/cart2.png">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        <template v-if="currentOptionInPopup && currentOptionInPopup.company_option && currentOptionInPopup.company_option.image">
          <template v-if="!currentOptionInPopup.image.includes('/placeholder.')">
            <div class="photo" :style="'background-image: url('+currentOptionInPopup.image+');'"></div>
          </template>
        </template>
        <div class="prod_white" style="background: #F5F5F5; position: relative; z-index: 2;">
          <div class="productModal__product" v-if="currentOptionInPopup">
            <div class="title" v-if="currentOptionInPopup">
              {{currentOptionInPopup.name}}
            </div>
            <div class="title__wraper">
              <div class="minMax" v-if="currentOptionInPopup.type == 'radio' && currentOptionInPopup.values.length > 1 && currentOptionInPopup.required">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span>{{$t('addOrder.selectMin')}} 1</span> 
                  </div>
              </div>
              <div class="minMax" v-if="currentOptionInPopup.min_no || currentOptionInPopup.max_no">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                    <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                  </svg>
                  <div>
                    <span>{{$t('addOrder.selectMinMax')}}</span> 
                    <span v-if="currentOptionInPopup.min_no">{{$t('addOrder.selectMin')}} {{currentOptionInPopup.min_no}}</span> 
                    <span v-if="currentOptionInPopup.max_no">{{$t('addOrder.selectMax')}} {{currentOptionInPopup.max_no}}</span>
                  </div>
              </div>
            </div>
          </div>

          <div class="options__wrapper" v-if="currentOptionInPopup">
            <div class="option">
              <div class="options">
                <div v-for="(values, keyVal) in currentOptionInPopup.values" :key="values.id" class="withPhoto">
                  <label :for="values.id" :class="{ 'checked': values.checked}">
                    <template v-if="(currentOptionInPopup.type === 'checkbox')">
                      <input :type="currentOptionInPopup.type"
                          :ref="'ref_' + values.id"
                          :name="currentOptionInPopup.id"
                          :disabled="values.disabled"
                          :value="values.id"
                          :id="values.id"
                          @change="updateCategories(currentOptionInPopup.id, values.id)"
                          v-model="values.checked"
                    >
                    <button @click="clickOnRef('ref_' + values.id)" :class="['option_button', values.disabled ? 'disabled' : '']">
                      <div class="col-photo">
                        <template v-if="currentOptionInPopup.values[keyVal].image.includes('/placeholder.')">
                          <div class="opt_photo" :style="'background-image: url('+companyLogo+');'" ></div>
                        </template>
                        <template v-else>
                          <div class="opt_photo" :style="'background-image: url('+currentOptionInPopup.values[keyVal].image+');'" ></div>
                        </template>
                      </div>
                      <div class="col-value">
                        <span>
                          {{values.name}}
                        </span>
                        <span v-if="getOptionValueStock(optionValueStockProductId(values)) >= 1" class="option_stock_badge">
                          <template v-if="getOptionValueStock(optionValueStockProductId(values)) > 99">{{$t('addOrder.sufficientStock')}}</template>
                          <template v-else>{{getOptionValueStock(optionValueStockProductId(values))}} {{$t('addOrder.available')}}</template>
                        </span>
                        <template v-if="!currentOptionInPopup.hide_prices">
                          <template v-if="optionHasDiscount(values)">
                            <span class="discount_badge">{{getOptionDiscountPercent(values)}} %</span>
                            <span class="old_opt_price" v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, false)"></span>
                            <span v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, true)"></span>
                          </template>
                          <span v-else-if="values.price > 0" v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, false)"></span>
                        </template>
                      </div>
                      <template v-if="values.company_option_value && values.company_option_value.allow_quantity && values.checked">
                        <div class="quantity-wrapper" @click.stop>
                          <quantity-selector
                            :value="values.quantity || 1"
                            :min="values.company_option_value.min_quantity || 1"
                            :max="getOptionValueMaxQuantity(currentOptionInPopup, values)"
                            @change="updateQuantityOptions(currentOptionInPopup.id, values, $event)"
                          />
                        </div>
                      </template>
                    </button>
                    </template>
                    <template v-else>
                      <input :type="currentOptionInPopup.type"
                          :ref="'ref_' + values.id"
                          :name="currentOptionInPopup.id"
                          :value="values.id"
                          :id="values.id"
                          @change="updateCategories(currentOptionInPopup.id, values.id)"
                          v-model="currentOptionInPopup.checked"
                    >
                    <button @click="clickOnRef('ref_' + values.id)" class="option_button">
                      <div class="col-photo">
                        <template v-if="currentOptionInPopup.values[keyVal].image.includes('/placeholder.')">
                          <div class="opt_photo" :style="'background-image: url('+companyLogo+');'" ></div>
                        </template>
                        <template v-else>
                          <div class="opt_photo" :style="'background-image: url('+currentOptionInPopup.values[keyVal].image+');'" ></div>
                        </template>
                      </div>
                      <div class="col-value">
                        <span>
                          {{values.name}}
                        </span>
                        <span v-if="getOptionValueStock(optionValueStockProductId(values)) >= 1" class="option_stock_badge">
                          <template v-if="getOptionValueStock(optionValueStockProductId(values)) > 99">{{$t('addOrder.sufficientStock')}}</template>
                          <template v-else>{{getOptionValueStock(optionValueStockProductId(values))}} {{$t('addOrder.available')}}</template>
                        </span>
                        <template v-if="!currentOptionInPopup.hide_prices">
                          <template v-if="optionHasDiscount(values)">
                            <span class="discount_badge">{{getOptionDiscountPercent(values)}} %</span>
                            <span class="old_opt_price" v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, false)"></span>
                            <span v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, true)"></span>
                          </template>
                          <span v-else-if="values.price > 0" v-html="getOptionPriceLabel(values, currentProductInPopup.price_details.currency_symbol, currentOptionInPopup.type === 'checkbox' ? (values.quantity || 1) : 1, false)"></span>
                        </template>
                      </div>
                    </button>
                    </template>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="footer" v-if="currentProductInPopup && !consultativeQrMenu">
        <div class="footer__price">
          <span>{{$t('addOrder.total')}}</span>
          <span v-html="getProductCartTotalPrice(currentProductInPopup, true)"></span>
        </div>
        <div class="footer__right">
          <div class="footer__addToCart">
            <template v-if="optionsInSteps && currentOptionInPopup && !currentOptionInPopup.is_the_last_option">
              <button @click="nextOptionToCart()" :disabled="verifyIfOptionIsDisabled()">
                {{$t('addOrder.next_to_option')}}
              </button>
            </template>
            <template v-else>
              <template v-if="currentProductInPopup.in_edit">
                <button :disabled="addToCartDisabled" @click="editToCart()">
                {{$t('addOrder.edit')}}</button>
              </template>
              <template v-else>
                <button :disabled="addToCartDisabled" @click="addToCart()">
                {{$t('addOrder.add')}}</button>
              </template>
            </template>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="cartModal"
            v-if="!consultativeQrMenu"
            v-model="showCartModal"
            :hideOverlay="true"
            :class="['cartModal', showCartModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="cart__wrapper">

        <div class="topBar">
          <div class="backButton" @click="showCartModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.cartDet')}}
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
          <div v-if="!consultativeQrMenu" class="cart" @click="showCart()">
            <img src="../../public/cart2.png">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>

        <div class="cartDetail">
          <div class="cartDetail__head">
            <div class="cartTitle" v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <span v-if="json.type != 'Kiosk'">{{json.type}} {{json.number}}</span>
            </div>
            <div class="packing_method" v-if="packingMethod">
              <span><b>{{$t('addOrder.'+packingMethod+'_first')}}</b> {{$t('addOrder.'+packingMethod+'_second')}}</span>
            </div>
            <div class="deleteAll" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && (selectedFingerprint === 'all' || fingerprint == selectedFingerprint) && cart.status !== 'OPEN_DRAFT'">
              <button class="emptyCart" v-if="cart && cart.myCart && cart.myCart.products.length" @click="emptyCartWithQuestion()">
                <emptyCartSvg /> {{$t('addOrder.emptyCartBtn')}}
              </button>
            </div>
          </div>

          <div class="cart_persons" v-if="
              cart && 
              cart.people && 
              cart.people.some(person => person.products && person.products.length > 0) && 
              (cart.people.length > 1) 
              && !withVivaWallet && 0 // am scos partea cu bulinele!
            ">
            <!-- Bulina pentru cosul general -->
            <div 
              @click="selectAll"
              :class="(selectedFingerprint == 'all') ? 'pers my all selected' : 'pers my all'"
            >
              <span>All</span>
            </div>
            <swiper
              :modules="swiperModule"
              :slides-per-view="slidersPerView"
              :space-between="10"
              :followFinger="true"
              :preventInteractionOnTransition="false"
              :autoHeight="true"
              :updateOnImagesReady="false"
              :preloadImages="false"
              :passiveListeners="true"
              :esistance="false"
              :observer="true"
              :observeParents="false"
              :observeSlideChildren="false"
              class="special-offer-block focus-in"
              >

              <!-- Buline pentru fiecare persoană -->
              <swiper-slide 
                @click="selectedFingerprint = fingerprint.toString()"
                :class="(selectedFingerprint == fingerprint) ? 'pers my selected' : 'pers my'"
              >
                <span>{{cart.people.filter(pp => pp.fingerprint == fingerprint)[0].initials}}</span>
              </swiper-slide>
              <template v-for="pers in cart.people" v-bind:key="pers.fingerprint">
                <swiper-slide v-if="pers.fingerprint != fingerprint" 
                  @click="selectedFingerprint = pers.fingerprint.toString()"
                  :class="(selectedFingerprint == pers.fingerprint) ? 'pers selected' : 'pers'" 
                >
                  <span>{{pers.initials}}</span>
                </swiper-slide>
              </template>
            </swiper>
          </div>
          
          <div class="products" v-if="cart && cart.people && cart.myCart && cart.myCart.products_count > 0">
            <!-- Template pentru cosul mare -->
            <template v-if="selectedFingerprint === 'all'">
              <div class="big-cart">
                <div class="selectAll" @click="toggleSelectAllPeople" v-if="!hasProductsEligibleForOpenOrder">
                  <p>
                    <img src="../../public/check-box.png">
                    {{selectAllText}}
                  </p>
                </div>
                <template v-for="person in sortedPeople" :key="person.fingerprint">

                  <div :class="(person.fingerprint == fingerprint) ? 'fgp my' : 'fgp'">

                    <!-- TITLU PERSOANĂ -->
                    <div class="fingerprint_title" @click="toggleProductBox(person.fingerprint)">
                      <div class="customCheckBoxQr">
                        <input
                          v-if="!hasProductsEligibleForOpenOrder"
                          type="checkbox"
                          :value="true"
                          v-model="getOrCreateSelectedPerson(person.fingerprint, false).selected"
                          @change="updatePersonProducts(person.fingerprint, false)"
                          @click.stop
                        />
                      </div>

                      <div style="display: flex; align-items: center; justify-content: center;">
                        <span>{{ person.full_name }}</span>
                        <span
                            v-if="fingerprint == person.fingerprint"
                            @click.stop="changeNameFgp()"
                            class="fingerprint_title_edit"
                          >
                          <!-- SVG pencil -->
                          <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                            <g id="pencil-square-fill" opacity="0.6">
                              <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                              <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                              <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                            </g>
                          </svg>
                        </span>
                      </div>

                      <span class="fingerprint_total">
                        {{ person.total_cart_price.toFixed(2) }} {{ currency_symbol }}
                      </span>
                    </div>
                    <!-- PRODUSE -->
                    <div v-if="isProductBoxVisible(person.fingerprint)">
                      <template v-for="prod in person.products" :key="prod.id + '-' + prod.index">

                        <div class="product">
                          <div class="product_details_wrapper2" style="width: 100%;">

                            <div style="display: contents;">
                              <!-- INFO PRODUS -->
                              <div class="infoProd">
                                <label
                                    class="description"
                                    :for="person.fingerprint + '-' + prod.id + '-' + prod.index"
                                  >
                                  <div class="ppt">

                                    <div class="leftPpt">
                                      <div class="customCheckBoxQr">
                                        <input
                                          v-if="!hasProductsEligibleForOpenOrder"
                                          type="checkbox"
                                          :id="person.fingerprint + '-' + prod.id + '-' + prod.index"
                                          :value="prod.id + '.' + prod.index"
                                          v-model="getOrCreateSelectedPerson(person.fingerprint, true).products"
                                          @change="updatePersonProducts(person.fingerprint, true)"
                                          @click.stop
                                          style="margin-right:10px"
                                        />
                                      </div>

                                      <div v-if="!prod.image.includes('placeholder')" class="col-image">
                                        <template v-if="prod.image">
                                          <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.image) + ');'">
                                          </div>
                                        </template>
                                      </div>

                                      <span class="product__name">
                                        x{{ prod.quantity }} {{ prod.name }}
                                      </span>
                                    </div>
                                    <div class="rightPpt" >
                                      <template v-if="!prod.hide_from_kds">
                                        <span v-if="!prod.is_prepared" class="in-processing">
                                          - {{ $t('addOrder.inProcesing') }}
                                        </span>
                                        <span v-else class="in-prepared">
                                          - {{ $t('addOrder.inPrepared') }}
                                        </span>
                                      </template>

                                      <!-- BUTOANE -->
                                      <div v-if="fingerprint == person.fingerprint && prod.hide_from_kds" class="col-buttons" style="max-width: 120px;">
                                        <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                                          <button v-if="prod.quantity > 1"
                                                  @click="editToCartUpdateQuantity(prod.quantity - 1, prod.id, prod.index)">-</button>
                                          <button v-else @click="deleteProductCart(prod.id, prod.index)">
                                            <emptyCartSvg />
                                          </button>

                                          <span>{{ prod.quantity }}</span>

                                          <button @click="editToCartUpdateQuantity(prod.quantity + 1, prod.id, prod.index)">+</button>
                                        </div>

                                        <div class="quantity" v-else>
                                          <button @click="deleteProductCart(prod.id, prod.index)">
                                            <emptyCartSvg />
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <span class="product__extra" v-if="prod.extra">
                                    {{ prod.extra }}
                                  </span>

                                  <div class="product_price" v-if="json.type != 'Kiosk'">
                                    <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                                  </div>
                                </label>

                              </div>
                            </div>

                          </div>
                        </div>

                      </template>
                    </div>
                  </div>

                </template>
              </div>
            </template>

            <template v-else>
              <template v-if="cart.people.length">
                <div :class="(selectedFingerprint == fingerprint) ? 'fgp my' : 'fgp' " v-if="selectedFingerprint">
                  <div class="fingerprint_title">
                    <span>{{$t('addOrder.guest')}}: {{cart.people.filter(pp => pp.fingerprint == selectedFingerprint)[0].full_name}} </span>
                    <span v-if="selectedFingerprint == fingerprint" @click="changeNameFgp()" class="fingerprint_title_edit">
                      <svg xmlns="http://www.w3.org/2000/svg" width="29.61" height="29.61" viewBox="0 0 29.61 29.61">
                        <g id="pencil-square-fill" opacity="0.6">
                          <path id="Path_104" data-name="Path 104" d="M0,0H29.61V29.61H0Z" fill="rgba(0,0,0,0)"/>
                          <path id="Path_105" data-name="Path 105" d="M6.935,4A4.935,4.935,0,0,0,2,8.935V21.272a4.935,4.935,0,0,0,4.935,4.935H19.273a4.935,4.935,0,0,0,4.935-4.935V10.712L13.992,20.927a1.234,1.234,0,0,1-.888.345H8.169a1.234,1.234,0,0,1-1.234-1.234V15.1a1.234,1.234,0,0,1,.345-.888L17.5,4Z" transform="translate(0.467 0.935)"/>
                          <path id="Path_106" data-name="Path 106" d="M17.5,4.468,7.28,14.683a1.234,1.234,0,0,0-.345.888v4.935A1.234,1.234,0,0,0,8.169,21.74H13.1a1.234,1.234,0,0,0,.888-.345L24.207,11.179V21.74a4.935,4.935,0,0,1-4.935,4.935H6.935A4.935,4.935,0,0,1,2,21.74V9.4A4.935,4.935,0,0,1,6.935,4.468ZM23.369,2.16,9.4,16.114v3.158h3.158L26.527,5.294a2.393,2.393,0,0,0,.148-.827,2.332,2.332,0,0,0-.753-1.8A2.467,2.467,0,0,0,24.207,2a2.307,2.307,0,0,0-.839.16Z" transform="translate(0.467 0.467)"/>
                        </g>
                      </svg>
                    </span>

                    <span v-if="cart.people.filter(pp => pp.fingerprint == selectedFingerprint)[0].payment_type" class="fingerprint_title_payed">{{$t('addOrder.isPayed')}}  ( {{cart.people.filter(pp => pp.fingerprint == selectedFingerprint)[0].payment_type}} )</span>
                  </div>
                  <!-- Template pentru produsele unei persoane selectate -->
                  <template v-for="prod in cart.myCart.products_sortBy_fingerprint[selectedFingerprint]" v-bind:key="prod.id">
                    <div class="product">
                      <div v-if="productIsIndisponible(prod.id) || cartLineIsUnorderable(prod)" class="outOfStockCart"> </div>
                      <span v-if="cartLineIsUnorderable(prod)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                      <span v-else-if="productIsIndisponible(prod.id)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                      <div class="product_details_wrapper">
                        <div @click="modifyProduct(prod)" style="display: contents;">
                          <div v-if="!prod.image.includes('placeholder')" class="col-image">
                            <template v-if="prod.image">
                              <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.image) + ');'">
                              </div>
                            </template>
                          </div>
                          <div class="col-info">
                            <div class="description">
                              <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                              <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>
                              <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id != 39">
                                <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                              </div>
                            </div>
                            <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id == 39" style="font-size: 1.56rem;">
                              <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                            </div>
                          </div>
                        </div>
                        <div v-if="fingerprint == selectedFingerprint && prod.hide_from_kds" class="col-buttons">
                          <div class="quantity" v-if="!prod.limit_quantity_kiosk_qr">
                            <button v-if="prod.quantity > 1" @click="editToCartUpdateQuantity(prod.quantity - 1, prod.id, prod.index)">-</button>
                            <button v-else @click="deleteProductCart(prod.id, prod.index)">
                              <emptyCartSvg />
                            </button>
                            <span>{{prod.quantity}}</span>
                            <button @click="editToCartUpdateQuantity(prod.quantity + 1, prod.id, prod.index)">+</button>
                          </div>
                          <div class="quantity" v-else>
                            <button @click="deleteProductCart(prod.id, prod.index)">
                              <emptyCartSvg />
                            </button>
                          </div>
                          <div class="delete">
                            <template>
                              <button class="product__delete" @click="deleteProduct(prod.id, prod.index)"><emptyCartSvg /></button>
                            </template>
                          </div>
                        </div>
                        <div v-else-if="fingerprint == selectedFingerprint && !prod.is_prepared" class="in-processing">
                          <p>{{$t('addOrder.inProcesing')}}</p>
                        </div>
                        <div v-else-if="fingerprint == selectedFingerprint && prod.is_prepared" class="in-prepared">
                          <p>{{$t('addOrder.inPrepared')}}</p>
                        </div>
                      </div>
                      <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                      <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span>
                    </div>
                  </template>
                </div>
              </template>
              
              <template v-else>
                <template v-for="prod in cart.myCart.products" v-bind:key="prod.id">
                  <div class="product">
                    <div v-if="productIsIndisponible(prod.id) || cartLineIsUnorderable(prod)" class="outOfStockCart"> </div>
                    <span v-if="cartLineIsUnorderable(prod)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                    <span v-else-if="productIsIndisponible(prod.id)" class="cartOutOfStockTxt">{{$t('addOrder.unavailable')}}</span>
                    <div class="product_details_wrapper">
                      <div @click="modifyProduct(prod)" style="display: contents;">
                        <div v-if="!prod.image.includes('placeholder')" class="col-image">
                          <template v-if="prod.image">
                            <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.image) + ');'">
                            </div>
                          </template>
                        </div>

                        <div class="col-info">
                          <div class="description">
                            <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                            <span class="product__is_bonus" v-if="prod.is_bonus">{{$t('addOrder.freeProd')}}</span>

                            <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id != 39">
                              <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                            </div>
                          </div>

                          <div class="product_price" v-if="json.type != 'Kiosk' && json.company_id == 39" style="font-size: 1.56rem;">
                            <span v-html="prod.price.toFixed(2) + ' ' + currency_symbol"></span>
                          </div>
                        </div>
                      </div>
                      <div v-if="fingerprint == selectedFingerprint && (
                          (prod.hasOwnProperty('status') && (!prod.status || prod.status == 'Draft')) ||
                          !prod.hasOwnProperty('status')
                        )" class="col-buttons">
                        <div class="quantity"  v-if="!prod.limit_quantity_kiosk_qr">
                          <button v-if="prod.quantity > 1" @click="editToCartUpdateQuantity(prod.quantity - 1, prod.id, prod.index)">-</button>
                          <button v-else @click="deleteProductCart(prod.id, prod.index)">
                            <emptyCartSvg />
                          </button>
                          <span>{{prod.quantity}}</span>
                          <button @click="editToCartUpdateQuantity(prod.quantity + 1, prod.id, prod.index)">+</button>
                        </div>
                        <div class="quantity" v-if="prod.limit_quantity_kiosk_qr">
                          <button @click="deleteProductCart(prod.id, prod.index)">
                            <emptyCartSvg />
                          </button>
                        </div>
                      </div>
                      <div v-else class="in-processing">
                        <p>{{$t('addOrder.inProcesing')}}</p>
                      </div>
                    </div>
                    <span class="product__additional_info" v-if="prod.additional_info">{{$t('addOrder.info')}}: {{prod.additional_info}}</span>
                    <span class="product__extra" v-if="prod.extra">{{prod.extra}}</span>
                  </div>
                </template>
              </template>
            </template>

            <template v-if="selectedFingerprint !== 'all' || (selectedFingerprint === 'all' && selectedTotalPrice > 0 )">
              <div class="tipsBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && cart.use_tips && (selectedFingerprint === 'all' || fingerprint == selectedFingerprint) && !hasProductsEligibleForOpenOrder">
                <div class="tipsInputsTitle">
                  <span>{{$t('addOrder.addTip')}}</span>
                </div>
                <div v-if="!isCollapsed" class="tipsBoxCollpase">
                  <div class="tipsInputs">
                    <div class="col col-one" 
                        :class="{ selected: selectedTip === 5, disabled: customTip !== '' && customTip !== null }"
                        @click="addTipDirectCart(5)">
                      <img src="../../public/smile.png">
                      <span> +5%</span>
                    </div>
                    <div class="col col-two" 
                        :class="{ selected: selectedTip === 10, disabled: customTip !== '' && customTip !== null }"
                        @click="addTipDirectCart(10)">
                      <img src="../../public/star.png">
                      <span> +10%</span>
                    </div>
                    <div class="col col-three" 
                        :class="{ selected: selectedTip === 15, disabled: customTip !== '' && customTip !== null }"
                        @click="addTipDirectCart(15)">
                      <img src="../../public/love.png">
                      <span> +15%</span>
                    </div>
                  </div>
                  <div class="custom-tip-input" :class="{ disabled: selectedTip !== null && (customTip === '' || customTip === null) }">
                    <input type="number" v-model="customTip" :placeholder="$t('addOrder.addTipValue')" :disabled="selectedTip !== null">
                    <button @click="addOrRemoveCustomTipCart">
                      {{ isCustomTipActive ? $t('addOrder.removeTipButton') : $t('addOrder.addTipButton') }}
                    </button>
                  </div>
                </div>
              </div>
            </template>
            
            <!-- <div class="couponBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && cart.use_coupon_discount && (selectedFingerprint === 'all' || fingerprint == selectedFingerprint)">
              <div class="couponInputsTitle" @click="toggleCouponCollapse">
                <span>{{$t('addOrder.couponBtn')}}</span>
              </div>
              <div v-if="isCouponCollapsed" class="inputCoupn">
                <input
                  type="text"
                  @keyup.enter="toggleCoupon"
                  v-model="couponText"
                  :placeholder="$t('addOrder.couponPlaceholder')"
                  name="couponCode"
                  ref="couponCode"
                  :disabled="couponApplied"
                >
                <button 
                  @click="toggleCoupon">
                  {{ couponApplied ? $t('addOrder.removeCouponButton') : $t('addOrder.couponButton') }}
                </button>
              </div>
            </div> -->

            <div class="commentClientsBox" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && (selectedFingerprint === 'all' || fingerprint == selectedFingerprint)">
              <div class="commentClientsTitle" @click="toggleCommentCollapse">
                <span>{{$t('addOrder.commentBtn')}}</span>
              </div>
              <div v-if="isCommentCollapsed" class="inputComment">
                <textarea name="info" maxlength="255" v-model="orderComments" :placeholder="$t('addOrder.infosup')"></textarea>
              </div>
            </div>
          </div>
          
          <div class="no_products_in_cart" v-if="cart && cart.myCart && cart.myCart.products_count <= 0 ">
            <p>{{$t('addOrder.empty')}}</p>
            <div class="middle">
              <svg xmlns="http://www.w3.org/2000/svg" width="49.288" height="49.275" viewBox="0 0 49.288 49.275">
                <g id="Iconly_Light_Bag" data-name="Iconly/Light/Bag" transform="translate(3 3)">
                  <g id="Bag">
                    <path id="Path_33955" d="M31.613,33.054H11.64C4.3,33.054-1.326,30.56.273,20.525l1.862-13.6C3.12,1.916,6.515,0,9.493,0H33.847c3.022,0,6.22,2.061,7.359,6.924l1.862,13.6C44.425,29.427,38.95,33.054,31.613,33.054Z" transform="translate(0 10.221)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Path_33956" d="M20.718,9.727C20.718,4.355,16.09,0,10.381,0h0A10.68,10.68,0,0,0,3.043,2.834,9.446,9.446,0,0,0,0,9.727H0" transform="translate(11.224 0)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_192" d="M.544.458H.435" transform="translate(28.156 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                    <path id="Line_193" d="M.544.458H.435" transform="translate(14.205 19.408)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="6"/>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <!-- Total pentru cosul mare -->
          <div class="totalCart" v-if="selectedFingerprint === 'all' && cart && cart.myCart && cart.myCart.products_count > 0">
            <!-- Display Tip Section -->
            <div class="orderTotalsOptions">
              <div v-if="tipValue > 0" class="totalsOptions">
                <span>{{ $t('addOrder.tip') }}</span>
                <span v-html="tipValue + ' ' + currency_symbol"></span>
              </div>
            </div>
            <div class="orderTotalsOptions">
              <template v-for="totalsOptions in cart.order_totals" v-bind:key="totalsOptions.name">
                <template v-if="totalsOptions.use">
                  <div class="totalsOptions" v-if="totalsOptions.value != 0">
                    <span>{{totalsOptions.name}}</span>
                    <span v-html="totalsOptions.value + ' ' + currency_symbol"></span>
                  </div>
                </template>
              </template>
            </div>
            <div class="orderTotal">
              <div class="total">
                <span>{{$t('addOrder.total')}}</span>
              </div>
              <div class="totalPrice">
                <span v-html="selectedTotalPrice + ' ' + currency_symbol"></span>
              </div>
            </div>
          </div>

          <!-- Total pentru cosul individual -->
          <template v-if="cart && cart.people">
            <template v-for="pers in cart.people" :key="pers.fingerprint">
              <div class="totalCart" v-if="selectedFingerprint === pers.fingerprint && cart && cart.myCart && cart.myCart.products_count > 0">
                <!-- Display Tip Section -->
                <div class="orderTotalsOptions">
                  <div v-if="tipValue > 0" class="totalsOptions">
                    <span>{{ $t('addOrder.tip') }}</span>
                    <span v-html="tipValue + ' ' + currency_symbol"></span>
                  </div>
                </div>
                <div class="orderTotalsOptions">
                  <template v-for="totalsOptions in cart.totalsOptions" :key="totalsOptions.name">
                    <template v-if="totalsOptions.use && totalsOptions.value !== 0">
                      <div class="totalsOptions">
                        <span>{{ totalsOptions.name }}</span>
                        <span v-html="totalsOptions.value + ' ' + currency_symbol"></span>
                      </div>
                    </template>
                  </template>
                </div>
                <div class="orderTotal">
                  <div class="total">
                    <span>{{$t('addOrder.total')}}</span>
                  </div>
                  <div class="totalPrice">
                    <span v-html="pers.total_cart_price + tipValue + ' ' + currency_symbol"></span>
                  </div>
                </div>
              </div>
            </template>
          </template>
        </div>

        <div class="footer" v-if="cart && cart.myCart && cart.myCart.products_count > 0 && (selectedFingerprint === 'all' || fingerprint == selectedFingerprint)">
          <div class="addToCart">
            <div class="addToCart__right">
              <template v-if="hasProductsEligibleForOpenOrder">
                <button 
                  v-if="fingerprint == selectedFingerprint || selectedFingerprint == 'all'"
                  class="orderNow"
                  :disabled="!hasProductsEligibleForOpenOrderForMy"
                  @click="openOrder()"
                >
                  <template v-if="hasProductsEligibleForOpenOrderForMy">
                    {{$t('addOrder.openOrder')}}
                  </template>
                  <template v-else>
                    {{$t('addOrder.openOrderNotAvailable')}}
                  </template>
                </button>
              </template>
              <template v-else>
                <button
                  class="orderNow" 
                  @click="handleOrderClick(selectedFingerprint)"
                  :disabled="isOrderNowDisabled"
                >
                  {{$t('addOrder.orderNow')}}
                </button>
                <span class="orderNowDesc">{{$t('addOrder.orderNowDesc')}}</span>
              </template>
            </div>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="paymentModal"
            v-if="!consultativeQrMenu"
            v-model="showPaymentModal"
            :hideOverlay="true"
            :class="['paymentModal', showPaymentModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="payment__wrapper">
        <div class="topBar">
            <div class="backButton" @click="showPaymentModal = false">
              <img src="../../public/arrow_back.svg">
            </div>
            <div class="title">
              {{$t('addOrder.payNavbar')}}
            </div>
            <div class="waiter" @click="confirmCallWaiter()">
              <img src="../../public/waiter3.png">
            </div>
            <div class="cart" @click="showPaymentModal = false">
              <img src="../../public/cart2.png">
              <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
                <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
              </template>
            </div>
          </div>
        <div class="round">
          <div class="fidelity" v-if="use_smso">
            <div class="fidelityTitle" @click="toggleFidelityCollapse">
              <span>{{$t('addOrder.phoneFidelityTitle')}}</span>
            </div>
            <div class="fidelityBox" v-if="isFidelityCollapsed">
              <div class="email_fields">
                <span>{{$t('addOrder.phoneFieldsTitle1')}}</span>
                <div class="phone_key_wrapper">
                  <div v-show="!client && !new_client">
                    <div class="inputPhone" >
                      <MazPhoneNumberInput
                        ref="clientPhoneField"
                        @click="changePhone()"
                        v-model="phone_to_send"
                        v-model:country-code="countryCode"
                        show-code-on-list  
                        @update="resultsPhone = $event"
                      />
                      <button @click="searchForClientMobile()">{{$t('addOrder.phoneSearch')}}</button>
                    </div>
                  </div>

                  <div class="client_fields" v-show="client || new_client">
                    <p v-if="client">{{$t('addOrder.client')}} {{maskPhoneNumber(client.phone)}}</p>
                    <p v-if="new_client">{{$t('addOrder.newClient')}} {{maskPhoneNumber(order_phone)}}</p>
                    <p v-if="new_client && loyalty_in_use" class="new_client">{{$t('addOrder.new_client_fidelity')}}</p>
                    <button @click="removeClient()">{{$t('general.cancel')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cui">
            <div class="cuiTitle" @click="toggleCuiCollapse">
              <span>{{ $t('addOrder.cuiPlaceholder') }}</span>
            </div>
            <div class="cuiBox" v-if="isCuiCollapsed">
              <div class="cui_fields" v-if="json.type != 'Kiosk'">
                <input id="cui" @click="changeCui()" type="text" v-model="cui" :placeholder="$t('addOrder.enterCui')">
              </div>
            </div>
          </div>
          <div class="titlePay">
            <p>{{$t('addOrder.howPay')}}</p>
          </div>
          <div class="pager_btn" v-if="json.type == 'Kiosk' && use_pager">
            <template v-if="pager">
              <button class="btnPager" @click="openPagerModal()">{{pager}}</button>
            </template>
            <template v-else>
              <button class="btnPager" @click="openPagerModal()">{{$t('addOrder.pagerBtn')}}</button>
            </template>
          </div>
          <div class="qr_code" v-if="qr_code">
            <div class="pack__wrapper__buttons_bg">
              <bgBtns />
            </div>
            <img :src="qr_code" alt="payByQr">
            <p><span>{{$t('addOrder.qrText')}}</span> <span> <div>{{countdown}}</div> </span> <span>{{$t('addOrder.qrText2')}}</span></p>
            <button class="qrCancel" @click="restart()">{{$t('addOrder.qrCancel')}}</button>
          </div>

          <div class="qr_code_steps" v-if="qr_code">
            <span>{{$t('addOrder.qrStep1')}}</span>
            <span>{{$t('addOrder.qrStep2')}}</span>
            <span>{{$t('addOrder.qrStep3')}}</span>
            <span>{{$t('addOrder.qrStep4')}}</span>
          </div>

          <div class="payment__buttons" v-if="!qr_code && addProductInCartRequest == 0">
            <div :class="[disablePaymentClass, 'viva_walet take', 'load_viva_walet']" @click="orderNow('viva_walet')" v-if='withVivaWallet && cart && cart.myCart && (cart.myCart.total_cart_price - (cart.myCart.total_pay_from_wallet || 0)) > 0'>
              <span>{{$t('addOrder.viva_walet')}}</span>
            </div>

            <div :class="[disablePaymentClass, 'pos', 'load_card_pos']" @click="orderNow('card_pos')" v-if='posPaymentEnabled && cart && cart.myCart && cart.myCart.total_cart_price > 0'>
              <span>{{$t('addOrder.pos')}}</span>
            </div>
            <template v-if="json.type == 'Kiosk'">
              <div :class="[disablePaymentClass, 'take', 'load_k_qr']" @click="orderNow('qr')" v-if='cardPaymentEnabled'>
                <qrSvg />
                <span>{{$t('addOrder.qr')}}</span>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_k_cash']" @click="orderNow('cash')" v-if='cashPaymentEnabled'>
                <span>{{$t('addOrder.counter')}}</span>
              </div>
            </template>
            <template v-else>
              <div :class="[disablePaymentClass, 'take', 'load_card', { 'selected': selectedPaymentMethod === 'card', 'disabled': selectedPaymentMethod !== 'card' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('card')" v-if='cardPaymentEnabled'>
                <span>{{$t('addOrder.card')}}</span>
                <div class="pay-image">
                  <div class="g-pay">
                    <img src="../../public/g-pay.svg">
                  </div>
                  <div class="g-pay">
                    <img src="../../public/apple-pay.svg">
                  </div>
                </div>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_cash', { 'selected': selectedPaymentMethod === 'cash', 'disabled': selectedPaymentMethod !== 'cash' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('cash')" v-if='cashPaymentEnabled'>
                <span v-if="json.company_id == 190">{{$t('addOrder.cash_bar')}}</span>
                <span v-else>{{$t('addOrder.cash_waiter')}}</span>
              </div>
              <div :class="[disablePaymentClass, 'din', 'load_pos', { 'selected': selectedPaymentMethod === 'pos', 'disabled': selectedPaymentMethod !== 'pos' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('pos')" v-if='posOnDeliveryPaymentEnabled'>
                <span v-if="json.company_id == 190">{{$t('addOrder.pos_bar')}}</span>
                <span v-else>{{$t('addOrder.pos_waiter')}}</span>
              </div>
            </template>
            <div :class="[disablePaymentClass, 'free', 'load_free', { 'selected': selectedPaymentMethod === 'free', 'disabled': selectedPaymentMethod !== 'free' && selectedPaymentMethod !== '' && cardPaymentEnabled }]" @click="orderNow('free')" v-if='freePaymentEnabled && cart && cart.myCart && (cart.myCart.total_cart_price - (cart.myCart.total_pay_from_wallet || 0)) <= 0'>
              <span>{{$t('addOrder.free')}}</span>
            </div>
          </div>
          <div class="payment__buttons" v-if="addProductInCartRequest != 0">
            <h2>{{$t('addOrder.weitingForAddToCartToFinish')}}</h2>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="splashScreenModal"
            v-model="showSplashScreenModal"
            :hideOverlay="true"
            :class="['splashScreenModal', showSplashScreenModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <template v-if="!packed && splashScreenBanners.length" v-for="(screen, key_s) in splashScreenBanners">
        <div :class="[nextSplashScreenSlider == key_s ? '' : 'hiden', 'splashScreen__wrapper']"  
            :style="'background-image: url(' + screen.image_landing + ');'"
        >
          <div class="orderNowQr">
            <button @click="exitSplashScreen()" class="generalButton">{{$t('addOrder.splashScreenOrderNow')}}</button>
          </div>
          <div class="languageBtns">
            <div 
              :class="['lang ro', curentLang == 'ro' ? 'selected' : '']" 
              @click.prevent="changeLanguageLocal('ro', 1)">
              <img src="../../public/ro-flag.svg">
            </div>
            <div 
              :class="['lang en', curentLang == 'en' ? 'selected' : '']" 
              @click.prevent="changeLanguageLocal('en', 1)">
              <img src="../../public/en-flag.svg">
            </div>
          </div>
          <div class="poweredByTaptasty">
            <poweredByTaptasty />
          </div>
        </div>
      </template>
      <div class="splashScreen__wrapper defaultOne" 
            v-if="splashScreenBanners.length <= 0"
            style="background-color: var(--principal)"
        >
        <div v-if="!companyLogo.includes('placeholder')" class="model">
          <img :src="companyLogo" alt="logo">
        </div>
        <div class="languageBtns">
          <div 
            :class="['lang ro', curentLang == 'ro' ? 'selected' : '']" 
            @click.prevent="changeLanguageLocal('ro', 1)">
            <img src="../../public/ro-flag.png">
          </div>
          <div 
            :class="['lang en', curentLang == 'en' ? 'selected' : '']" 
            @click.prevent="changeLanguageLocal('en', 1)">
            <img src="../../public/en-flag.png">
          </div>
        </div>
        <div class="orderNowQr">
          <button @click="exitSplashScreen()" class="generalButton">{{$t('addOrder.splashScreenOrderNow')}}</button>
        </div>
        <div class="poweredByTaptasty">
          <poweredByTaptasty />
        </div>
      </div>
      
    </vue-final-modal>

    <vue-final-modal
            name="completeModal"
            v-model="showCompleteModal"
            :hideOverlay="true"
            :class="['completeModal', showCompleteModal ? 'active': '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="complete__wrapper">

        <div class="top__pack__wrapper">
          <div class="model" style="position: relative;">
            <splashIcons width="100%" top="-100px" left="0" />
            <img :src="companyLogo" alt="logo">
          </div>
        
          <div class="round">
            <div class="roundbg"></div>

            <div class="title_wrapper">
              <div class="dialog" style="background-image: url('./dialog.png');">
                <span>{{$t('addOrder.doneShortly')}}</span>
              </div>
              <h2>{{$t('addOrder.thenks')}}</h2>
            </div>

            <div class="order_nr_wrapper">
              <div class="pack__wrapper__buttons_bg">
                <bgBtns />
              </div>
              <div class="order_nr">
                <svg xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
                  <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
                    <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
                      <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
                      <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
                    </g>
                  </g>
                </svg>
                <div class="order_nr_txt"> 
                  <span>{{$t('addOrder.yourOrderNr')}}</span>
                  <span>{{finishOrderNr}}</span>
                </div>
              </div>
            </div>

            <div class="steps">
              <div class="step">
                <div class="step_round">1</div>
                <span>{{$t('addOrder.step1')}}</span>
              </div>
              <div class="step">
                <div class="step_round">2</div>
                <span>{{$t('addOrder.step2')}}</span>
              </div>
            </div>

            <div class="back">
              <button @click="restart">{{$t('addOrder.back')}}</button>
            </div>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="posModal"
            v-model="showPosModal"
            :hideOverlay="true"
            class="posModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="posModal__wrapper">

        <svg class="rotating" xmlns="http://www.w3.org/2000/svg" width="412" height="412" viewBox="0 0 412 412">
          <g id="Group_12353" data-name="Group 12353" transform="translate(-308.587 -759.587)">
            <g id="Group_12340" data-name="Group 12340" transform="translate(309 760)">
              <circle id="Ellipse_423" data-name="Ellipse 423" cx="163" cy="163" r="163" transform="translate(42.587 42.587)" fill="#ffca40"/>
              <path id="Union_8" data-name="Union 8" d="M125.814,395.81A206.236,206.236,0,0,1,15.506,127.444l.291-.7a1.55,1.55,0,0,1,2.158-.774l2.572,1.371a1.545,1.545,0,0,1,.7,1.962A199.721,199.721,0,0,0,40.153,317.817a200.571,200.571,0,0,0,88,72.47A199.731,199.731,0,0,0,317.82,371.848c4.881-3.3,9.689-6.867,14.288-10.608a1.547,1.547,0,0,1,1.371-.3l3.477.915a1.549,1.549,0,0,1,.6,2.689A206.284,206.284,0,0,1,125.814,395.81Zm65.37-15.533h0a172.9,172.9,0,0,1-60.761-16.965,1.549,1.549,0,0,1-.659-2.169l1.385-2.384a1.548,1.548,0,0,1,2.019-.615c2.718,1.328,5.5,2.595,8.271,3.766a166.891,166.891,0,0,0,50.515,12.575,1.553,1.553,0,0,1,1.39,1.818l-.488,2.7c0,.005,0,.013,0,.018a1.554,1.554,0,0,1-1.522,1.258C191.281,380.282,191.232,380.28,191.184,380.277Zm34.526-1.241a1.591,1.591,0,0,1-.193-.633l-.337-2.637a1.546,1.546,0,0,1,1.359-1.737,167.561,167.561,0,0,0,74.619-27.649,168.917,168.917,0,0,0,61.027-74.107,168.19,168.19,0,0,0-15.53-159.722,168.932,168.932,0,0,0-74.108-61.027A168.205,168.205,0,0,0,112.824,67.053,168.962,168.962,0,0,0,51.8,141.16,168.185,168.185,0,0,0,67.328,300.885a169.33,169.33,0,0,0,38.284,40.343,1.548,1.548,0,0,1-.04,2.5c-.842.592-1.63,1.152-2.354,1.663a1.552,1.552,0,0,1-1.836-.033A176.04,176.04,0,0,1,78.642,324.6a174.241,174.241,0,1,1,148.6,55.222h-.017a1.578,1.578,0,0,1-.161.009A1.554,1.554,0,0,1,225.71,379.036Zm154.033-65.042,0,0-.024-.013-2.529-1.456a1.552,1.552,0,0,1-.548-2.153,200.83,200.83,0,0,0,13.649-26.524A199.729,199.729,0,0,0,371.847,94.179a200.62,200.62,0,0,0-88-72.466A199.724,199.724,0,0,0,94.179,40.153c-2.542,1.714-5.118,3.544-7.654,5.437a1.551,1.551,0,0,1-2.34-.609l-1.214-2.712a1.552,1.552,0,0,1,.491-1.878A206.023,206.023,0,0,1,381.815,313.444l-.011.018a1.55,1.55,0,0,1-2.061.532Zm-343-217.222L34.16,95.4a1.548,1.548,0,0,1-.569-2.217A207.5,207.5,0,0,1,57.9,62.817a1.548,1.548,0,0,1,2.408.226l1.634,2.484a1.548,1.548,0,0,1-.178,1.924,201.507,201.507,0,0,0-21.6,26.726c-.458.678-.924,1.375-1.384,2.076a1.532,1.532,0,0,1-.187.233,1.559,1.559,0,0,1-1.838.286Z" transform="translate(-0.413 -0.413)" fill="#ffca40"/>
            </g>
          </g>
        </svg>
        <h2>{{$t('addOrder.payByCard')}}</h2>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="couponModal"
            v-model="showCouponModal"
            :hideOverlay="true"
            class="couponModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="couponModal__wrapper" @click="closeCouponModal()">

        <div class="couponModal__img__wrapper">
          <couponSvg />
        </div>

        <h2>{{$t('addOrder.couponTitle')}}</h2>
        <input type="text" @keyup.enter="applyCoupon(true)" v-model="couponText" :placeholder="$t('addOrder.couponPlaceholder')" name="couponCode" ref="couponCode">
        <button v-if="json.type != 'Kiosk'" @click="applyCoupon(true)">{{$t('addOrder.couponBtn')}}</button>
        <span v-if="json.type == 'Kiosk'">{{$t('addOrder.couponExit')}}</span>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="pagerModal"
            v-model="showPagerModal"
            :hideOverlay="true"
            class="pagerModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="pagerModal__wrapper" @click="closePagerModal()">
        <div class="xModalBtn" @click="showPagerModal = false"><span>x</span></div>
        <div class="couponModal__img__wrapper">
          <img :src="'../pager.png'" alt="pager">
        </div>
        <h2>{{$t('addOrder.pagerTitle')}}</h2>
        <input type="text" @keyup.enter="applyPager()" id="pagerInput" ref="pagerInput" v-model="pagerText" :placeholder="$t('addOrder.pagerPlaceholder')" name="pagerInput">
        <span>{{$t('addOrder.couponExit')}}</span>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="soldWithModal"
            v-model="showSoldWithModal"
            :hideOverlay="true"
            :focus-trap="false"
            :class="['soldWithModal', showSoldWithModal ? 'active' : '']"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="soldWithModal__wrapper">
        <div class="topBar">
          <div class="backButton" @click="showSoldWithModal = false">
            <img src="../../public/arrow_back.svg">
          </div>
          <div class="title">
            {{$t('addOrder.soldWithTitle')}}
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
          <div v-if="!consultativeQrMenu" class="cart" @click="showCart()">
            <img src="../../public/cart2.png">
            <template v-if="cart && cart.myCart && cart.myCart.products_count > 0">
              <div :class="bounceCartQuantity ? 'roundNr bounce' : 'roundNr'">{{cart.myCart.products_count}}</div>
            </template>
          </div>
        </div>
        
        <div class="products__wrapper">
          <template v-for="products in soldWithCategory" v-bind:key="products.id">
            
            <div class="SW_products" v-if="soldWithCategory && soldWithCategory.length > 0">
              <span class="cat_title">{{products.title}}</span>
              <template v-for="prod in products.products" v-bind:key="prod.id">
                <div :class="prod.active ? 'SW_product active' : 'SW_product' " @click="selectSoldWithProduct(prod)">
                  <div class="col-photo">
                      <template v-if="prod.src">
                        <div class="product__photo" :style="'background-image: url(' + encodeURI(prod.src) + ');'">
                        </div>
                      </template>
                  </div>
                  <div class="col-info">
                    <div class="description">
                      <span class="product__name">{{getProductNameFromCart(prod)}}</span>
                    </div>
                    
                    <div class="product_details">
                      <div class="product_price">
                        <template v-if="prod.use_price_to_show && prod.price_to_show > 0 && !productHasDiscount(prod)">
                          <span v-html="soldWithProductDisplayPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                        </template>
                        <template v-else-if="productHasDiscount(prod)">
                          <p class="discount_badge">{{getProductDiscountPercent(prod)}} %</p>
                          <span class="old_prod_price" v-html="soldWithProductListPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                          <span v-html="soldWithProductDisplayPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                        </template>
                        <template v-else>
                          <span v-html="soldWithProductDisplayPrice(prod).toFixed(2) + ' ' + currency_symbol"></span>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </template>
        </div>

        <div class="soldWithBottomBar">
          <div class="soldWithBottomBar__right">
            <button
              class="soldWithAddBtn"
              @click="handleButtonClick"
              :class="{ jumpOverClass: !selectedSoldWithProducts.length }"
            >
              {{ selectedSoldWithProducts.length ? $t('addOrder.soldWithAdd') : $t('addOrder.jumpOver') }}
              <img v-if="!selectedSoldWithProducts.length" src="../../public/skip-right.png" />
            </button>
          </div>
        </div>

      </div>
    </vue-final-modal>

    <vue-final-modal
            name="iframeModal"
            v-model="showIframeModal"
            :hideOverlay="true"
            class="iframeModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showIframeModal = false, onePaymentAllreadyPicked = false"><span>x</span></div>

        <iframe :src="paymentLinkForIframe" id="paymentFrame" frameborder="0"></iframe>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="settingsModal"
            v-model="showSettingsModal"
            :hideOverlay="true"
            class="settingsModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showSettingsModal = false; clearKeyBoard()"><span>x</span></div>
        <h1>Settings</h1>
        <div class="settings_buttons" v-if="!corectPass">
          <input type="text" v-model="thePass" placeholder="pass">
          <br>
          <button @click="verifyPass()">Enter</button>
        </div>
        <div class="settings_buttons" v-if="corectPass">
          <button @click="getRaport('Z')">GET Z</button>
          <br>
          <button @click="getRaport('X')">GET X</button>
        </div>
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="p9Modal"
            v-model="showP9Modal"
            :hideOverlay="true"
            class="p9Modal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="iframeModal__wrapper">
        <div class="xModalBtn" @click="showP9Modal = false; swiperTutorial.slideTo(0)"><span>x</span></div>
        
        <swiper
          :modules="swiperModuleTutorial"
          @swiper="onSwiperTutorial"
          effect="fade"
          scrollbar
          :loop="false"
          :grabCursor="false"
          :centeredSlides="true"
          :autoplay="{
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false
          }"
          class="swipper_tutorial special-offer-block focus-in"
        >
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h1>Bine ai venit la Piața9 Cetate!</h1>
              <h2 style="margin-bottom: 5px;">Dacă ești pentru prima dată te rugăm să iei în considerare câteva aspecte importante</h2>
              <button @click="swiperTutorial.slideTo(1)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s2.png'" alt="p9_tutorial_s2">
              <h2 style="margin-bottom: 0;">Comanda se face direct de la masă:  scanezi codul QR — adaugi produsele în coș — confirmi comanda.</h2>
              <button @click="swiperTutorial.slideTo(2)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s3.png'" alt="payment_tutorial3" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Poți plăti direct online, la finalizarea comenzii, folosind Apple Pay, Google Wallet sau cardul bancar.</h2>
              <h2>Te rugăm să urmezi cu atenție toți pașii indicați de platformă și de aplicațiile terțe implicate.</h2>
              <button @click="swiperTutorial.slideTo(3)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s4.png'" alt="payment_tutorial4" style="width: 100%; max-width: 300px;">
              <h1>FOARTE IMPORTANT!</h1>
              <h2 style="margin-bottom: 5px;">Comanda ta este validată doar în momentul în care primești un mesaj clar de confirmare din partea noastră.</h2>
              <button @click="swiperTutorial.slideTo(4)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_s5.png'" alt="payment_tutorial5" style="width: 100%; max-width: 300px;">
              <h2 style="margin-bottom: 0;">Ai și opțiunea să plătești cu NUMERAR sau cu CARDUL la POS.</h2>
              <h2>În acest caz, pentru a confirma comanda și a efectua plata, prezintă colegilor de la bar mesajul primit la finalizarea comenzii.</h2>
              <button @click="swiperTutorial.slideTo(5)" class="settings_buttons_btn1">Înainte</button>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div class="settings_buttons">
              <img :src="'../p9_tutorial_logo.png'" alt="p9_tutorial_logo">
              <h2>Dacă ai orice fel de întrebare sau nelămurire, nu ezita să apelezi la colegii noștri prezenți în locație.</h2>
              <button @click="showP9Modal = false; swiperTutorial.slideTo(0)" class="settings_buttons_btn1">Comandă</button>
            </div>
          </swiper-slide>
        </swiper>

        
      </div>
    </vue-final-modal>

    <vue-final-modal
            name="paymentSuccessModal"
            v-model="showPaymentSuccessModal"
            :hideOverlay="true"
            class="paymentSuccessModal"
            classes="modal-container"
            content-class="modal-content"
      >
      <div class="productModal__wrapper">
        <div class="topBar">
          <div class="backButton">
            <!-- <img src="../../public/arrow_back.svg"> -->
          </div>
          <div class="title">
            {{$t('addOrder.thenks')}}
          </div>
          <div class="waiter" @click="confirmCallWaiter()">
            <img src="../../public/waiter3.png">
          </div>
        </div>
        <div class="thankYou">
          <div class="image">
            <img src="../../public/thankYou.svg">
          </div>
          <div class="title">
            {{$t('addOrder.thenks')}}
          </div>
          <div class="orderNumber">
            {{$t('addOrder.orderNumber')}}: <span v-if="oldOrder.series">{{oldOrder.series}} - </span> <span>{{oldOrder.number}}</span>
          </div>
          <div class="orderNumber">
            ID: <span>{{ oldOrder.order_id }}</span>
          </div>
          <div class="orderSuccess">
            <p>{{$t('addOrder.finishOrderMsg')}}</p>
          </div>
          <div class="historyOrders">
            <div class="title" @click="toggleOrdersHistoryCollapse">
              {{$t('addOrder.ordersHistory')}}
            </div>
            <div class="historyProducts" v-if="isOrdersHistoryCollapsed">
              <!-- Afișează lista de persoane -->
              <div v-if="oldOrder.people && oldOrder.people.length">
                <div v-for="person in oldOrder.people" :key="person.id" class="person-info">
                  <div class="people">
                    <div class="people__name">
                      <div>{{$t('addOrder.guest')}}: <span>{{ person.full_name ? person.full_name : person.fingerprint }}</span></div>
                      <div v-if="!person.full_name">{{ person.fingerprint }}</div>
                    </div>
                    <div class="people_total">
                      <div>Total: <span>{{ person.total_cart_price + ' ' + currency_symbol }}</span></div>
                    </div>
                  </div>
                  <div v-if="person.products && person.products.length">
                    <div v-for="product in person.products" :key="product.id" class="product-info">
                      <div class="col-image">
                        <img :src="product.image" alt="Product Image" class="product-image"/>
                        <div class="box-info">
                          <div class="product__name">x{{ product.quantity }} {{ product.name }}</div>
                          <div class="product__extre">{{ product.extra }}</div>
                          <div v-if="product.additional_info" class="product__extre">{{$t('addOrder.info')}}: {{ product.additional_info }}</div>
                        </div>
                      </div>
                      <div class="col-info-price">
                        <div class="product__price">{{ product.price  + ' ' + currency_symbol }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="newScan">
              <p>{{$t('addOrder.newScan')}}</p>
            </div>
          </div>
        </div>
      </div>
    </vue-final-modal>

    <div id="swal-template"></div>
  </div>
</template>

<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
import { sharedFunction } from '../mixins/sharedFunction.js'
import Swal from 'sweetalert2'
import ProductOptionsTable from '../components/ProductOptionsTable';
import QuantitySelector from '../components/QuantitySelector.vue';

import settingsSvg from './svg/settingsSvg';
import bgBtns from './svg/bgBtns';
import cardSvg from './svg/cardSvg';
import counterSvg from './svg/counterSvg';
import posSvg from './svg/posSvg';
import qrSvg from './svg/qrSvg';
import splashIcons from './svg/splashIcons';
import splashScreen from './svg/splashScreen';
import freeSvg from './svg/freeSvg';
import couponSvg from './svg/couponSvg';
import emptyCartSvg from './svg/emptyCartSvg';
import poweredByTaptasty from './svg/poweredByTaptasty';
export default {
  mixins: [utilsMixin, sharedFunction],
  name: 'OrderViewTable',
  components: {
    ProductOptionsTable,
    QuantitySelector,
    settingsSvg,
    bgBtns,
    cardSvg,
    counterSvg,
    posSvg,
    qrSvg,
    splashIcons,
    splashScreen,
    couponSvg,
    emptyCartSvg,
    freeSvg,
    poweredByTaptasty
  },
  props: {
    msg: String
  },
  data () {
    return {
      // in sharedFunction
      allProdSelected: 1,
      slidersPerView: 4,
      whiteColor: "#fff",
      isCollapsed: false,
      isCouponCollapsed: false,
      isFidelityCollapsed: false,
      isCommentCollapsed: false,
      isTipsValueCollapsed: false,
      isCuiCollapsed: false,
      isOrdersHistoryCollapsed: false,
      products: [],
      visibleProductBoxes: new Set(),
      isSearchBarVisible: false,
      customTip: '',
    }
  },
  mounted() {
    this.selectedTip = null;
    //remove keyboard on click
    //let elNotKey = document.querySelector("html");
    // elNotKey.addEventListener('touchend', (event) => {
    //   let keyEl = document.querySelector(".simple-keyboard");
    //   let langBtnEl = document.querySelector(".lang_btn");
    //   let langBtnEl2 = document.querySelector(".pack__wrapper .lang_btn");
    //   if (this.activeKeyboard && !keyEl.contains(event.target) ) {
    //     this.activeKeyboard = false;
    //   }
    //   if (!this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl.contains(event.target) ) {
    //     this.listOfLangIsOpen = false;
    //   }
    //   if (this.showSplashScreenModal && this.listOfLangIsOpen && !langBtnEl2.contains(event.target)) {
    //     this.listOfLangIsOpen = false;
    //   }
    //   if (!document.querySelector(".callWaiter").contains(event.target) || !document.querySelector(".callWaiter").contains(event.target)) {
    //     this.waiterStep0 = false;
    //     this.waiterStep1 = false;
    //     this.waiterStep2 = false;
    //   }
    // }, false);

    // handleGesture
    let touchableElement = document.querySelector(".productList");
    if (touchableElement) {
      touchableElement.addEventListener('touchstart', (event) => {
          this.touchstartX = event.changedTouches[0].screenX;
          this.touchstartY = event.changedTouches[0].screenY;
          // if(touchableElement.scrollTop + touchableElement.offsetHeight == touchableElement.scrollHeight) {
          if (touchableElement.scrollHeight - touchableElement.offsetHeight <= touchableElement.scrollTop + 2) {
            this.bottomReach = 1
          } else {
            this.bottomReach = 0
          }
          if(touchableElement.scrollTop == 0) {
            this.topReach = 1
          } else {
            this.topReach = 0
          }
      }, false);

      touchableElement.addEventListener('touchend', (event) => {
          this.touchendX = event.changedTouches[0].screenX;
          this.touchendY = event.changedTouches[0].screenY;
          this.handleGesture(touchableElement)
      }, false);

      // scrool effect
      this.setScroolVars(touchableElement, this.activeProductList)
      touchableElement.addEventListener('scroll', (event) => {
          this.setScroolVars(touchableElement, this.activeProductList)
          if (this.activeProductList.bottom == false && this.json.type == 'Kiosk') {
            this.infoShown.bottom = true
          } else {
            this.infoShown.bottom = false
          }
      }, false);
    }

    //disabled contextmenu
    if (!window.is_local) {
      document.addEventListener("contextmenu", function (e) {
          e.preventDefault();
      }, false);
    }

    // scrool effect
    let filterElement = document.querySelector(".filter__cat");
    if (filterElement) {
      this.setScroolVars(filterElement, this.activeFilter)
      filterElement.addEventListener('scroll', (event) => {
        this.setScroolVars(filterElement, this.activeFilter)
      }, false);
    }

    // "Do you want to order something else?" popup (QR menu only, not kiosk).
    // Any user activity resets the inactivity countdown.
    this.onUserActivityForReorder = this.onUserActivityForReorder.bind(this)
    document.addEventListener('touchstart', this.onUserActivityForReorder, true)
    document.addEventListener('mousedown', this.onUserActivityForReorder, true)
    document.addEventListener('keydown', this.onUserActivityForReorder, true)
    this.armReorderPopupTimer()
  },
  beforeDestroy () {
    clearTimeout(this.reorderPopupTimer)
    document.removeEventListener('touchstart', this.onUserActivityForReorder, true)
    document.removeEventListener('mousedown', this.onUserActivityForReorder, true)
    document.removeEventListener('keydown', this.onUserActivityForReorder, true)
  },
  watch: {
    reorder_popup_minutes () {
      this.armReorderPopupTimer()
    }
  },
  created () {
    this.restart()
    let innerWidth = window.innerWidth > 700 ? 700 : window.innerWidth
    innerWidth -= 120
    this.slidersPerView = Math.floor(innerWidth / (50+10) ) + 0.5;
    addEventListener("resize", (event) => {
      let innerWidth = window.innerWidth > 700 ? 700 : window.innerWidth
      innerWidth -= 120
      this.slidersPerView = Math.floor(innerWidth / (50+10) ) + 0.5;
    });
  },
  computed: {
    consultativeQrMenu() {
      return this.json && this.json.type !== 'Kiosk' &&
        [254].includes(Number(this.json.company_id));
    },
    sortedPeople() {
      if (!this.cart?.people?.length) return [];

      const myFingerprint = String(this.fingerprint);

      const me = this.cart.people.find(
        p => String(p.fingerprint) === myFingerprint
      );

      const others = this.cart.people.filter(
        p => String(p.fingerprint) !== myFingerprint
      );

      return me ? [me, ...others] : others;
    },
    hasSingleFingerprint() {
      return Object.keys(this.cart.myCart.products_sortBy_fingerprint).length === 1;
    },
    // selectAllText() {
    //   return this.selectedPeopleAndProducts.length === this.cart.people.length ? 
    //          this.$t('addOrder.deselectAll') : 
    //          this.$t('addOrder.allSelect');
    // },
    selectAllText() {
      // const allSelected = Object.values(this.selectedPeopleAndProducts).every(personData => {
      //   return personData.selected || personData.products.length === 0;
      // });

      return this.allProdSelected ? this.$t('addOrder.deselectAll') : this.$t('addOrder.allSelect');
    },
    // selectedTotalPrice() {
    //   if (this.selectedPeople.length === 0) {
    //     return '0'; // Return 0 when no people are selected
    //   } else if (this.selectedPeople.length === this.cart.people.length) {
    //     // When all people are selected, return the total cart price including the tip
    //     const totalCartPrice = parseFloat(this.cart.myCart.total_cart_price);
    //     const totalWithTip = totalCartPrice + (this.tipValue || 0); // Add tipValue to total

    //     return totalWithTip.toString(); // Return total including tip as string
    //   } else {
    //     // Calculate total for selected people only
    //     const total = this.cart.people
    //       .filter(person => this.selectedPeople.includes(person.fingerprint))
    //       .reduce((total, person) => total + person.total_cart_price, 0);

    //     // Add the tip value if applicable
    //     const totalWithTip = total + (this.tipValue || 0); // Add tipValue to the calculated total

    //     return totalWithTip.toString(); // Return total including tip as string
    //   }
    // },
    selectedTotalPrice() {
      let total = 0;

      if (!this.hasProductsEligibleForOpenOrder) {
        for (const [fingerprint, personData] of Object.entries(this.selectedPeopleAndProducts)) {
          const person = this.cart.people.find(p => p.fingerprint === fingerprint);
          if (!person) continue;

          const selectedProductsTotal = person.products
            .filter((product, index) => {
              const uniqueKey = `${product.id}.${product.index}`;
              return personData.products.includes(uniqueKey);
            })
            .reduce((sum, product) => sum + product.price, 0);

          total += selectedProductsTotal;
        }
      } else {
        // totalul la toti
        // total = this.cart.people
        //     .flatMap(person => person.products)
        //     .reduce((sum, product) => sum + product.price_unit * product.quantity, 0);
        
        return Number(this.cart.total_order_price).toFixed(2);
      }

      if (total <= 0) {
        this.tipValue = 0
        this.customTip = ''
        this.selectedTip = null
      }


      total += Number(this.tipValue || 0);

      // toate din order_totals inafara de tips
      const extraTotals = (this.cart.order_totals || [])
        .filter(t => t.use && t.name !== 'Tip')
        .reduce((sum, t) => sum + Number(t.value || 0), 0);

      total += extraTotals;

      this.cart.myCart.total_cart_price = total // nu stiu daca asta e ok aici!!

      if (this.selectedTip) {
        this.addTipDirectCart(this.selectedTip, 1);
      }

      return Number(total).toFixed(2);
    },
    hasProductsEligibleForOpenOrderForMy() {
      let products = this.cart.myCart.products_sortBy_fingerprint[this.fingerprint];

      if(products) {
          for (var i = 0; i < products.length; i++) {
            if(products[i].hide_from_kds) {
                return true;
            }
          }
        }

      return false;
    },
    hasProductsEligibleForOpenOrder() {
      let products = [] 
      if (this.cart.people.length) {
        if(this.selectedFingerprint == 'all') {
          products = this.cart.myCart.products;
        } else {
          products = this.cart.myCart.products_sortBy_fingerprint[this.selectedFingerprint];
        }
      } else {
        products = this.cart.myCart.products;
      }
      if(this.allow_open_order) {
        if(products) {
          for (var i = 0; i < products.length; i++) {
            if(products[i].hide_from_kds) {
                return true;
            }
          }
        }
      }

      return false;
    },
    isCustomTipActive() {
      return parseFloat(this.customTip) === parseFloat(this.tipValue);
    },
    // Cate PRODUSE sunt efectiv bifate (nu totalul: ambalajul/taxa/SGR/tip din
    // order_totals umfla totalul chiar cu 0 produse bifate).
    selectedProductsCount() {
      return Object.values(this.selectedPeopleAndProducts || {})
        .reduce((n, pd) => n + ((pd && Array.isArray(pd.products)) ? pd.products.length : 0), 0);
    },
    isOrderNowDisabled() {
      if (this.selectedFingerprint === 'all') {
        // Daca nu e bifat NICIUN produs, nu lasam sa se plateasca (chiar daca exista
        // ambalaj/taxa care ar face totalul > 0).
        return this.selectedProductsCount === 0;
      } else {
        const person = this.cart.people.find(p => p.fingerprint === this.selectedFingerprint);
        return person ? person.total_cart_price === 0 : true;
      }
    }
  },
  methods: {
    addToCart (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.addToCart.apply(this, args);
    },
    editToCart (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.editToCart.apply(this, args);
    },
    addTOCartExtra (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.addTOCartExtra.apply(this, args);
    },
    addProductDirectlyToCart (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.addProductDirectlyToCart.apply(this, args);
    },
    showCart (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.showCart.apply(this, args);
    },
    handleOrderClick (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.handleOrderClick.apply(this, args);
    },
    payNew2 (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.payNew2.apply(this, args);
    },
    openOrder (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.openOrder.apply(this, args);
    },
    orderNow (...args) {
      if (this.consultativeQrMenu) return;
      return sharedFunction.methods.orderNow.apply(this, args);
    },
    updateQuantityOptions (opId, values, newQuantity) {
      values.quantity = newQuantity;
      this.updateCategories(opId, values.id);
    },
    // --- Reorder popup ("do you want to order something else?") ---
    reorderPopupEnabled () {
      // NOTE: the "cart has products" check is intentionally NOT here — the
      // inactivity timer must always run so the countdown starts even if the
      // user adds a product and never taps again. The cart is checked only at
      // popup-open time, in showReorderPopupNow().
      return this.json.type != 'Kiosk' &&
             !!this.reorder_popup_minutes &&
             this.reorder_popup_minutes > 0 &&
             !this.reorderPopupDone
    },
    cartHasProductsForReorder () {
      // Only OPEN the popup if the cart currently holds at least one product.
      return !!(this.cart && this.cart.myCart && this.cart.myCart.products_count > 0)
    },
    armReorderPopupTimer () {
      clearTimeout(this.reorderPopupTimer)
      if (!this.reorderPopupEnabled() || this.reorderPopupOpen) {
        return
      }
      const delay = this.reorder_popup_minutes * 60 * 1000
      this.reorderPopupTimer = setTimeout(() => {
        this.showReorderPopupNow()
      }, delay)
    },
    onUserActivityForReorder () {
      // Any touch resets the countdown; the popup fires once per session.
      if (!this.reorderPopupEnabled() || this.reorderPopupOpen) {
        return
      }
      this.armReorderPopupTimer()
    },
    showReorderPopupNow () {
      if (!this.reorderPopupEnabled() || this.reorderPopupOpen) {
        return
      }
      // Cart check happens HERE (at open time), not at arm time: if the cart is
      // empty right now, don't open — just re-arm and try again next interval.
      if (!this.cartHasProductsForReorder()) {
        this.armReorderPopupTimer()
        return
      }
      // Fire once: don't re-arm after this.
      this.reorderPopupDone = true
      this.reorderPopupOpen = true
      clearTimeout(this.reorderPopupTimer)

      Swal.fire({
        title: this.$t('addOrder.reorderPopupQuestion'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: false,
        allowOutsideClick: false,
        target: document.getElementById('swal-template'),
        customClass: {
          container: 'smallSwall',
        }
      }).then((result) => {
        this.reorderPopupOpen = false
        this.logReorderPopupResponse(result.isConfirmed ? 'YES' : 'NO')
      })
    },
    logReorderPopupResponse (answer) {
      this.apiRequest('/log-reorder-popup-response', 'POST', {
        company_id: this.json.company_id,
        location_id: this.locationTrueId || null,
        table_id: this.json.id,
        order_id: (this.cart && this.cart.order_id) ? this.cart.order_id : null,
        order_token: this.shopping_cart_id || null,
        response: answer,
      }, () => {})
    },
    // in sharedFunction
    deleteProductCart(prodId, prodIndex) {
      let className = this.json.type == 'Kiosk' ? 'bigSwall' : 'smallSwall';
      Swal.fire({
        title: this.$t('addOrder.emptyCartProduct'),
        confirmButtonText: this.$t('addOrder.yes'),
        cancelButtonText: this.$t('addOrder.no'),
        showCancelButton: true,
        showCloseButton: true,
        target: document.getElementById('swal-template'),
        customClass: {
          container: className,
        }
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteProduct(prodId, prodIndex)
        }
      })
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    toggleCouponCollapse() {
      this.isCouponCollapsed = !this.isCouponCollapsed;
    },
    toggleFidelityCollapse() {
      this.isFidelityCollapsed = !this.isFidelityCollapsed;
    },
    toggleCommentCollapse() {
      this.isCommentCollapsed = !this.isCommentCollapsed;
    },
    toggleTipsValueCollapse() {
      this.isTipsValueCollapsed = !this.isTipsValueCollapsed;
    },
    toggleCuiCollapse() {
      this.isCuiCollapsed = !this.isCuiCollapsed;
    },
    toggleOrdersHistoryCollapse() {
      this.isOrdersHistoryCollapsed = !this.isOrdersHistoryCollapsed;
    },
    // toggleSelectAllPeople() {
    //   if (this.cart && this.cart.people && this.cart.people.length) {
    //     if (this.selectedPeople.length === this.cart.people.length) {
    //       this.selectedPeople = [];
    //     } else {
    //       this.selectedPeople = this.cart.people.map(person => person.fingerprint);
    //     }
    //   }
    // },
    toggleSelectAllPeople() {
      this.allProdSelected = Object.values(this.selectedPeopleAndProducts).every(personData => personData.selected);

      if (!this.allProdSelected) {
        this.cart.people.forEach(person => {
          const personData = this.getOrCreateSelectedPerson(person.fingerprint, false);
          personData.selected = true;

          personData.products = person.products.map((product, index) => `${product.id}.${product.index}`);
        });
        this.allProdSelected = true;
      } else {
        this.cart.people.forEach(person => {
          const personData = this.getOrCreateSelectedPerson(person.fingerprint, false);
          personData.selected = false;
          personData.products = [];
        });
        this.allProdSelected = false;
      }
    },
    selectAll() {
      this.selectedFingerprint = 'all';
    },
    areAllProductsOrdered() {
      const products = this.cart.myCart.products_sortBy_fingerprint[this.selectedFingerprint] || [];
      return !products.some(prod => 
        (prod.hasOwnProperty('status') && (!prod.status || prod.status === 'Draft')) || 
        !prod.hasOwnProperty('status')
      );
    },
    toggleProductBox(fingerprint) {
      if (this.visibleProductBoxes.has(fingerprint)) {
        this.visibleProductBoxes.delete(fingerprint);
      } else {
        this.visibleProductBoxes.add(fingerprint);
      }
    },
    isProductBoxVisible(fingerprint) {
      return true;
      if (this.withVivaWallet) {
        return true;
      } else {
        return this.visibleProductBoxes.has(fingerprint);
      }
    },
    getOrCreateSelectedPerson(fingerprint, clickedOnProduct) {
      if (!this.selectedPeopleAndProducts[fingerprint]) {
        this.selectedPeopleAndProducts[fingerprint] = {
          selected: false,
          products: [],
        };
      }
      
      this.allProdSelected = Object.values(this.selectedPeopleAndProducts).every(personData => personData.selected);

      return this.selectedPeopleAndProducts[fingerprint];
    },
    updatePersonProducts(fingerprint, clickedOnProduct) {

      this.getOrCreateSelectedPerson(fingerprint, clickedOnProduct);

      const personData = this.selectedPeopleAndProducts[fingerprint];
      const personProducts = this.cart.people.find(p => p.fingerprint === fingerprint)?.products || [];

      if (clickedOnProduct) {
        const allSelected = personProducts.every((product, index) => 
          personData.products.includes(`${product.id}.${product.index}`)
        );
        personData.selected = allSelected;
      } else {
        if (personData.selected) {
          personData.products = personProducts.map((product, index) => `${product.id}.${product.index}`);
        } else {
          personData.products = [];
        }
      }
    },
    toggleSearchBar() {
      this.isSearchBarVisible = !this.isSearchBarVisible;
    },
    handleButtonClick() {
      if (this.selectedSoldWithProducts.length) {
        this.addTOCartExtra();
      } else {
        this.showSoldWithModal = false;
      }
    },
  }
}
</script>

<style scoped lang="scss">
  @import "./scss/OrderViewMobile.scss";

  .ppt {
    display:flex; 
    align-items:center; 
    justify-content: space-between;
    .leftPpt {
      display: flex; 
      align-items: center; 
      justify-content: flex-start;
    }
    .rightPpt {
      display: flex; 
      align-items: center; 
      justify-content: flex-end;
      min-width: 80px;
    }
  }

  .orderNowQr {
    position: absolute;
    bottom: 180px;
    width: 100%;
    z-index: 9999999;
    .generalButton {
      height: 70px !important;
      font-size: 24px !important;
    } 
  }

  .right_cart_total {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .col-buttons {
      margin-right: 10px;
    }
  }

  .cart {
    img {
      width: 35px;
    }
  }
  .waiter {
    img {
      width: 35px;
    }
  }

  .poweredByTaptasty {
    position: relative;
    top: 20px;
    svg {
      max-width: 150px;
    }
  }
  .paymentSuccessModal {
    .productModal__wrapper {
      margin-bottom: 0px;
    }
    .footer {
      height: auto;
      background: #fff;
      button {
        max-width: 350px;
        width: calc(100% - 20px) !important;
        height: 56px;
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border: 0px;
        border-radius: 50px;
        background: var(--addBtnColor);
      }
    }
    .topBar {
      justify-content: space-between;
      .waiter {
        position: relative;
        right: 10px;
      }
    }
    .thankYou {
      margin-top: 50px;
      .image {
        img {
          max-width: 240px;
          margin-bottom: 40px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 600;
      }
      .orderNumber {
        margin-top: 15px;
        font-size: 16px;
        span {
          font-weight: 600;
        }
      }
      .orderSuccess {
        padding: 0 40px;
        p {
          font-size: 15px;
        }
      }
    }
  }
  .callWaiter {
    position: absolute;
    right: 5%;
    bottom: 10%;
    width: 70px;
    height: 70px;
    z-index: 999;
    border-radius: 100%;

    svg {
      position: absolute;
    }

    .callWaiter__buttons {
      position: absolute;
      filter: url("#goo");
      
      &.step-0 {
        .callWaiter__social-btn-1, .callWaiter__social-btn-2 {
          transform: translate3d(-50px, -50px, 0);
        }
      }
      &.step-1 {
        .callWaiter__social-btn-1 {
          transform: translate3d(-50px, -50px, 0);
        }
        .callWaiter__social-btn-2 {
          transform: translate3d(-50px, 50px, 0);
        }
        .callWaiter__social-btn-3 {
          transform: translate3d(-50px, 50px, 0);
        }
      }
      &.step-2 {
        .callWaiter__social-btn-1 {
          transform: translate3d(-10px, -70px, 0);
        }
        .callWaiter__social-btn-2 {
          transform: translate3d(-70px, 0px, 0);
        }
        .callWaiter__social-btn-3 {
          transform: translate3d(-10px, 70px, 0);
        }
      }
    }
    
    .callWaiter__social-btn {
      position: absolute;    
      left: 0;
      top: 0;
      
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      background: var(--addBtnColor);
      color: var(--addBtnColorInv);
      
      border-radius: 50%;
      transition: all 0.2s ease;
      
      &:hover {
        color: var(--addBtnColorInv);
        box-shadow: 0 0 15px var(--addBtnColor);
      }
      span {
        text-align: center;
        font-size: 12px;
        line-height: 1;
      }
    }
    
    .callWaiter__open-btn {
      position: absolute;
      left: 0;
      top: 0;
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
      
      background: var(--addBtnColor);
      color: var(--addBtnColorInv);
      
      border-radius: 50%;
      
      transition: all 0.2s ease;
      
      &:hover {
        color: var(--addBtnColorInv);
        box-shadow: 0 0 15px var(--addBtnColor);
      }
      span {
        text-align: center;
        font-size: 12px;
        line-height: 1;
      }
    }
  }
  .swal2-title {
    color: #000 !important;
  }
  .swal2-styled.swal2-confirm {
    font-size: 18px !important;
  }
  .languageBtns {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    position: relative;
    margin-bottom: 30px;
    z-index: 2;
    height: calc(100% - 100px);
    div {
      margin: 0px 8px;
      &.selected {
        img {
          height: 54px;
          border: 5px solid #ffff;
          border-radius: 16px;
        }
      }
      img {
        border-radius: 16px;
      }
    }
  }

  .soldWithModal,
  .cartModal {
    .cart_persons {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 70px;
      margin-top: 0px;
      padding-left: 10px;
      .pers.all {
        width: 50px !important;
        height: 40px !important;
        margin-left: 10px;
        transform: scale(1.1);
        &::after {
          content: "";
          position: absolute;
          right: -10px;
          width: 1px;
          height: 40px;
          background: #c0bdbd;
        }
      }
      >.swiper {
        padding: 10px;
      }
      .all {
        background: green !important;
        border: 1px solid green !important;
      }
      .pers {
        width: 50px !important;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: var(--addBtnColor);
        color: var(--addBtnColorInv);
        font-size: 1.3rem;
        font-weight: bold;
        border-radius: 100%;
        margin-right: 20px;
        transition: 0.2s;
        opacity: 0.5;
        &.my {
          background: var(--principal);
          color: #fff;
          transition: 0.2s;
          opacity: 1;
        }
        &.selected {
          // border-bottom-right-radius: 0;
          // border-bottom-left-radius: 0;
          transform: scale(1.1);
          transition: 0.2s;
          border: 1px solid #000;
        }
      }
    }
    .backBar {
      position: relative;
      bottom: 0;
    }
  }
  .backBar {
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    bottom: 180px;
    width: 100%;
    z-index: 2;
    height: 100px;
    background: #fff;
    .backButon {
      font-size: 2rem;
      font-weight: 700;
      padding: 10px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--addBtnColorInv);
      background: #fff;
      border: 1px solid var(--principal);
      svg {
        height: auto;
        width: 30px;
        margin-right: 12px;
        fill: var(--principal);
      }
    }
  }

  .minMax {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 0px;
    margin-top: 5px;
    color: #E2B5BF;
    background: transparent;
    border: 0;
    padding: 0;
    margin-bottom: 5px;
    font-size: 15px;
    font-weight: 500;
  }
  .options__wrapper {
    margin: 10px;
    margin-top: 10px;
    border-radius: 20px;
    padding: 0px;
  }
  .options {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    .withPhoto {
      width: calc(50% - 20px);
      margin-right: 10px;
      margin-left: 10px;
      margin-bottom: 12px;
      position: relative !important;
    }
    label {
      // display: flex;
      // align-items: center;
      // justify-content: center;
      // margin-bottom: 20px;
    }
    input {
      opacity: 0;
      position: absolute;
    }
    .col-photo {
      width: 40%;
    }
    .col-value {
      span {
        min-height: 70px;
        padding: 5px 2px;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        display: flex;
        font-size: 13px;
      }
    }
    .opt_photo {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 50px;
      height: 50px;
      margin-right: 5px;
      border-radius: 14px;
    }
    .option_button {
      // width: calc(100% - 40px);
      // margin-left: 20px;
      // margin-right: 20px;
      display: flex;
      // align-items: center;
      // justify-content: flex-start;
      border-radius: 10px;
      background: #fff;
      padding: 10px 20px;
      position: relative;
      overflow: hidden;
      &.disabled {
        opacity: 0.5;
      }
      .discount_badge {
        position: absolute;
        top: 4px;
        left: -28px;
        transform: rotate(-45deg);
        font-size: 0.75rem;
        font-weight: bold;
        color: #fff;
        width: 100px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 3;
        margin: 0;
        pointer-events: none;
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 18px;
          background: red;
          z-index: -1;
        }
      }
      .old_opt_price {
        position: relative;
        color: red !important;
        &:before {
          content: "";
          position: absolute;
          left: 0;
          top: 50%;
          width: 100%;
          height: 1px;
          background: red;
        }
      }
      span {
        font-size: 1.7rem;
        margin-left: 20px;
        color: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          font-size: 2rem;
          color: #000;
        }
      }
    }
    input:checked ~ .option_button {
      background-color: var(--addBtnColor);
      color: var(--addBtnColorInv);;
      span {
        color: var(--addBtnColorInv);;
        span {
          color: var(--addBtnColorInv);;
        }
      }
      .old_opt_price {
        color: red !important;
        &:before {
          background: red;
        }
      }
    }
  }

  .fastTip {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 50px;
    z-index: 999;
    border-radius: 0;
    button {
      border-radius: 0;
      background: var(--principal);
      color: var(--secundar);
      width: 100%;
      height: 100%;
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }


  .swipeUpForMore {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 4;
    font-size: 12px;
    transition: 0.5s;
    opacity: 0;
    &.show {
      transition: 0.5s;
      opacity: 1;
    }
    svg {
      fill: var(--principal);
      transform: rotate(90deg);
      width: 40px;
    }
    span {
      color: var(--principal);
      margin-top: 10px;
    }
  }
  .posModal {
    .posModal__wrapper {
      position: relative;
      h2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        margin: 0;
        font-size: 3rem;
        font-weight: 700;
      }
    }
  }
  .soldWithModal {
    .soldWithBottomBar {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      background: #f5f5f5;
      .soldWithBottomBar__right {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
      .with {
        span{
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;
          text-decoration: underline;
          font-weight: 500;
          img {
            width: 20px;
            margin-top: 3px;
          }
        }
      }
      .soldWith_total_extra {
        height: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        background: #fff;
        color: var(--principal);
        span {
          &:first-of-type {
            font-size: 1.75rem;
            font-weight: 400;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .soldWithAddBtn {
        max-width: 320px;
        width: calc(100% - 20px);
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border: 0px;
        border-radius: 50px;
        background: var(--addBtnColor);
        padding: 20px 40px;
        height: 100%;
        margin-left: 40px;

        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          fill: #000;
          stroke: #000;
          width: 40px;
          height: 40px;
          margin-right: 15px;
        }
        &:disabled {
          opacity: 0.5;
        }
      }
      .jumpOverClass {
        background: transparent;
        color: #000;
        text-decoration: underline;
        img {
          width: 20px;
          margin-top: 3px;
          margin-left: 4px;
        }
      }
      .soldWithNoBtn {
        width: 30%;
        height: 100%;
        border: 1px solid #fff;
        background: transparent;
        padding: 20px;
        color: #fff;
        font-size: 1.87rem;
        font-weight: 400;
      }
    }
    .soldWithModal__wrapper {
      background: #F5F5F5;
      width: 100%;
      height: 100%;
    }
    .products__wrapper {
      // scrool div
      width: 100%;
      height: calc(100% - 440px);
      max-height: calc(100vh - 440px);
      padding: 0px 10px;
      overflow: auto;
    }
    .products__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .products__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: var(--principal);
    }
    .products__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
    .soldWithTopBar {
      width: 100%;
      height: 160px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      h2 {
        margin: 0;
        font-size: 20px;
        font-weight: 500;
      }
    }
    .soldWithBottomBar {
      width: 100%;
      height: 180px;
      padding: 20px;
    }
    .SW_products {
      display: flex;
      align-items: stretch;
      justify-content: flex-start;
      flex-wrap: wrap;
      padding-top: 60px;
      margin-bottom: 0px;
      position: relative;
      // border-bottom: 1px solid var(--secundar);
      span.cat_title {
        position: absolute;
        left: 10px;
        top: 30px;
        font-size: 16px;
        font-weight: 500;
        color: #000;
      }
      .SW_product {
        width: calc(33.33% - 20px);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 10px;
        margin-top: 0;
        margin-bottom: 30px;
        border-radius: 10px;
        background: #fff;
        padding: 10px;
        position: relative;
        &::after {
          content: "";
          background-image: url('../../public/add.svg');
          background-size: contain;
          background-repeat: no-repeat;
          position: absolute;
          top: -10px;
          right: -10px;
          width: 25px;
          height: 25px;
          pointer-events: none;
          z-index: 4;
        }
        &.active {
          background: var(--principal);
          color: #fff;
          .product_price {
            color: #fff;
          }
          .old_prod_price {
            color: red;
            &:before {
              background: red;
            }
          }
          &::after {
            content: "";
            background-image: url('../../public/check.svg') !important;
            background: #0f6015;
            border: 2px solid #fff;
            background-repeat: no-repeat;
            border-radius: 50px;
            background-position: center;
            background-size: 13px;
            position: absolute;
            top: -10px;
            right: -10px;
            width: 25px;
            height: 25px;
            pointer-events: none;
          }
        }
        .discount_badge {
          position: absolute;
          top: 6px;
          left: -32px;
          transform: rotate(-45deg);
          font-size: 0.75rem;
          font-weight: bold;
          color: #fff;
          width: 110px;
          height: 28px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3;
          margin: 0;
          pointer-events: none;
          &:before {
            content: "";
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            height: 18px;
            background: red;
            z-index: -1;
          }
        }
        .old_prod_price {
          font-size: 0.95rem;
          font-weight: 500;
          position: relative;
          color: red;
          display: inline-block;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 1px;
            background: red;
          }
        }
        .col-photo {
          width: 40%;
        }
        .product__photo {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          width: 50px;
          height: 50px;
          margin-right: 8px;
          border-radius: 14px;
        }
        .description {
          font-size: 14px;
          font-weight: 500;
          margin-top: 0px;
          margin-bottom: 10px;
          text-align: left;
        }
        .product_price {
          font-size: 14px;
          font-weight: 500;
          color: var(--principal);
          margin-bottom: 20px;
          text-align: left;
        }
      }
    }
    
  }
  .pagerModal {
    .pagerModal__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 200px;
      .couponModal__img__wrapper {
        img {
          max-width: 300px;
        }
      }
    }
    h2 {
      font-size: 30px;
      font-weight: 500;
      color: #1F3D73;
    }
    input {
      width: 70%;
      border: 1px solid #1F3D73;
      border-radius: 4px;
      padding: 10px 15px;
      color: #1F3D73;
      text-align: center;
      font-size: 16px;
      &::placeholder {
        color: #1F3D73;
        opacity: 1; /* Firefox */
      }
    }
    span {
      color: var(--principal);
      position: absolute;
      left: 50%;
      bottom: 15px;
      transform: translateX(-50%);
      margin-bottom: 20px;
    }
  }
  .couponModal {
    .couponModal__wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding-bottom: 200px;
      .couponModal__img__wrapper {
        img {
          max-width: 300px;
        }
      }
    }
    h2 {
      font-size: 30px;
      font-weight: 500;
      color: var(--iconsColor1);
    }
    input {
      width: 70%;
      border: 1px solid var(--iconsColor1);
      border-radius: 4px;
      padding: 10px 15px;
      color: var(--iconsColor1);
      text-align: center;
      font-size: 16px;
      &::placeholder {
        color: var(--iconsColor1);
        opacity: 1; /* Firefox */
      }
    }
    span {
      color: var(--principal);
      position: absolute;
      left: 50%;
      bottom: 15px;
      transform: translateX(-50%);
      margin-bottom: 20px;
    }
  }
  .iframeModal {
    .iframeModal__wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      iframe {
        width: 100%;
        height: 100%;
      }
    }
  }
  .payment__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    .payhBottomBar {
      width: 100%;
      margin-bottom: 30px;
      button {
        max-width: 350px;
        width: calc(100% - 20px) !important;
        height: 56px;
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border-radius: 50px;
      }
    }
    .round {
      width: 100%;
      height: 80%;
      position: absolute;
      left: 0;
      bottom: 0;
      padding-top: 20px;
      overflow: hidden;
      .cui {
        .cuiTitle {
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          margin: 0 20px;
          padding-top: 20px;
          padding-bottom: 20px;
          border-bottom: 1px solid #DFDFDF;
          span {
            text-decoration: underline;
          }
        }
        .cuiBox {
          input {
            border-radius: 50px;
            font-size: 14px;
            height: 43px;
            padding: 5px 20px;
            margin: 5px 0px;
            width: calc(100% - 40px);
            margin-bottom: 20px;
            box-shadow: initial;
            margin-top: 15px;
          }
        }
      }
      .fidelity {
        .fidelityTitle {
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          margin: 0 20px;
          padding-top: 10px;
          border-bottom: 1px solid #DFDFDF;
          padding-bottom: 20px;
          color: green;
          span {
            text-decoration: underline;
          }
        }
      }
      .titlePay {
        p {
          font-size: 16px;
          font-weight: 600;
          text-align: left;
          padding: 0 20px;
          margin-bottom: 10px;
        }
      }
      .logo_t {
        position: absolute;
        left: 0;
        bottom: 5%;
        width: 100%;
      }
      h2 {
        position: relative;
        color: #fff;
        font-size: 4.37rem;
        font-weight: 400;
        margin-top: 0;
        margin-bottom: 0;
        z-index: 2;
      }
      .roundbg_wrapper {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
      }
      .roundbg {
        width: 200%;
        height: 100%;
        background: var(--principal);
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: 0;
        border-top-right-radius: 50%;
        border-top-left-radius: 50%;
      }
    }
    .payment__tableName {
      font-size: 12px;
      z-index: 1;
      color: #fff;
      position: relative;
      margin-bottom: 10px;
      display: block;
    }
    .email_fields,
    .cui_fields {
      .client_fields {
        p {
          font-size: 16px;
        }
        button {
          height: 43px;
          padding: 10px 0px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
          border-radius: 50px;
        }
        .new_client {
          font-size: 14px;
          width: calc(100% - 40px);
          margin: auto;
          margin-bottom: 10px;
          font-style: italic;
        }
      }
      .inputPhone {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        max-width: 350px !important;
        font-size: 1.5rem !important;
        margin: auto;
        margin-top: 10px !important;
        .m-input.--md {
          height: 4em !important;
          .m-input-wrapper-input {
            input {
              padding-left: 3.25rem !important;
              position: relative !important;
              top: 4px !important;
            }
          }
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 43px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
      input {
        width: 300px;
        font-size: 2rem;
        background: #fff;
        border: 0;
        border-radius: 10px;
        box-shadow: 0px 0px 20px -10px rgba(0, 0, 0, 0.75);
        padding: 10px 5px;
        text-align: left;
      }
    }
    .email_fields {
      span {
        position: relative;
        display: block;
        color: #000;
        padding: 10px 20px;
        text-align: left;
        font-size: 16px;
      }
      .inputPhone {
        width: 100%;
        max-width: 350px;
        font-size: 1rem;
        margin: auto;
        margin-top: 5px;
        @media screen and (max-width: 500px) {
          max-width: 300px;
        }
      }
      input {
        width: 100%;
        max-width: 350px;
        border-radius: 50px;
        font-size: 14px;
        height: 43px;
        padding: 5px 20px;
        margin: 5px 0px;
        box-shadow: none;
        text-align: left;
        @media screen and (max-width: 500px) {
          max-width: 300px;
        }
      }
    }
    .pager_btn {
      position: relative;
      z-index: 2;
      margin-bottom: 30px;
      .btnPager {
        position: relative;
        font-size: 2rem;
        width: 300px;
        font-weight: bold;
        background: var(--iconsColor1);
        color: var(--iconsColor2);
      }
    }
    .total {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: max-content;
      height: auto;
      margin: auto;
      color: var(--addBtnColorInv);
      background: var(--addBtnColor);
      z-index: 2222;
      position: relative;
      border-radius: 15px;
      padding: 20px 50px;
      margin-bottom: 20px;
      width: 300px;
      @media screen and (max-width: 500px) {
        width: 200px;
      }
      @media screen and (max-width: 400px) {
        width: 180px;
        margin-top: 10px;
      }
      span {
        display: block;
        &:first-of-type {
          font-size: 2.56rem;
          font-weight: 500;
        }
        &:last-of-type {
          font-size: 3.81rem;
          font-weight: 700;
        }
      }
    }
  }
  .qr_code {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60%;
    width: 100%;
    img {
      width: 510px;
      height: 510px;
      z-index: 2;
      padding: 10px;
      background: #fff;
      border-radius: 40px;
    }
    p {
      width: 500px;
      font-size: 2.25rem;
      font-weight: 400;
      color: #fff;
      margin: 0;
      margin-top: 20px;
      z-index: 2;
      span {
        min-width: 50px;
        >div {
          min-width: 40px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -6.25rem;
      min-height: 500px;
    }
    .qrCancel {
      background: var(--addBtnColor);
      margin-top: 20px;
      color: var(--addBtnColorInv);
      font-size: 2.56rem;
      font-weight: 500;
      z-index: 2;
    }
  }
  .qr_code_steps {
    position: relative;
    width: 100%;
    height: 20%;
    padding-left: 40px;
    padding-right: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #fff;
    position: absolute;
    left: 0;
    bottom: 40px;
    span {
      font-size: 20px;
      font-weight: 300;
      font-style: italic;
      display: block;
      text-align: left;
      width: 100%;
    }
  }
  .order_view {
    position: relative;
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    &.withKey {
      height: calc(100vh - 450px);
    }
  }
  .swiper,
  .swiper-slide {
    width: 100%;
    height: 100%;
  }
  .banner {
    width: 100%;
    height: 500px;
    display: flex;
    .banner_img {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .hide-loader {
    display: none;
  }
  h3 {
    margin: 40px 0 0;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .productModal__wrapper {
    height: calc(100% - 100px);
    overflow: auto;
    margin-bottom: 100px;
  }
  .optionModal {
    .productModal__wrapper {
      .photo {
        // padding-bottom: 40%;
        // background-size: contain;
      }
      .prod_white {
        overflow: auto;
        height: calc(100% - 76px);
        .withPhoto {
          label {
            // position: relative !important;

            &::after {
              content: "";
              background-image: url('../../public/add.svg');
              background-size: contain;
              background-repeat: no-repeat;
              position: absolute;
              top: -10px;
              bottom: 0px;
              right: -10px;
              width: 25px;
              height: 25px;
              pointer-events: none;
            }
          }
          label.checked {
            // position: relative;
            &::after {
              content: '';
              background-image: url('../../public/check.svg') !important;
              background: #0f6015;
              border: 2px solid #fff;
              background-repeat: no-repeat;
              border-radius: 50px;
              background-position: center;
              background-size: 13px;
              position: absolute;
              top: -10px;
              bottom: 0px;
              right: -10px;
              width: 25px;
              height: 25px;
              pointer-events: none;
            }
          }
        }
        .option_button {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          row-gap: 8px;
          border-radius: 12px;
          padding: 12px;
          width: 100%;
          box-shadow: 0px 4px 12px -7px rgba(0,0,0,0.1);
          position: relative;
          .col-photo {
            width: 56px;
            flex: 0 0 56px;
          }
          .opt_photo {
            width: 56px;
            height: 56px;
            border-radius: 12px;
            margin: 0;
          }
          .col-value {
            width: auto;
            flex: 1 1 0;
            min-width: 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 4px;
            padding-left: 10px;
            span {
              display: block;
              min-height: 0;
              margin: 0;
              padding: 0;
              text-align: left;
              font-size: 15px;
              font-weight: 600;
              line-height: 1.25;
            }
            span:nth-child(1) {
              min-height: 0;
            }
            .option_stock_badge {
              order: 1;
              margin: 0;
              font-weight: 700;
            }
          }
          /* stepper drops to the bottom, full width, separated by a subtle divider */
          .quantity-wrapper {
            width: 100%;
            flex: 1 1 100%;
            margin: 2px 0 0;
            padding-top: 10px;
            border-top: 1px solid rgba(255, 255, 255, 0.3);
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
  .optionModal,
  .productModal {
    .productModal__wrapper {
      height: calc(100% - 280px);
      max-height: calc(100% - 280px);
      // max-height: calc(80vh - 180px);
      overflow: auto;
    }
    .productModal__wrapper::-webkit-scrollbar {
        width: 5px;
    }
    .productModal__wrapper::-webkit-scrollbar-thumb {
        border-radius: 100px;
        border: 0px solid transparent;
        background-clip: content-box;
        background-color: var(--principal);
    }
    .productModal__wrapper::-webkit-scrollbar-track {
        background-color: #e4e4e4;
        border-radius: 100px;
    }
    .photo {
      width: calc(100% - 40px);
      height: auto;
      padding-bottom: 80%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: sticky;
      top: 20px;
      z-index: 1;
      margin: 20px;
      border-radius: 20px;
      // max-width: 200px;
      // img {
      //   max-width: 100%;
      //   border-radius: 25px
      // }
    }
    .productModal__product {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-direction: column;
      padding: 20px 40px;
      border-top-right-radius: 30px;
      border-top-left-radius: 30px;
      // margin-top: -30px;
      z-index: 2;
      position: relative;
      margin-top: 0;
      .title {
        font-size: 16px;
        font-weight: 500;
      }
      .minMax {
        svg {
          margin-right: 5px;
        }
      }
      .title__wraper {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        p {
          font-size: 15px;
          font-weight: 500;
          text-align: left;
          line-height: 1.5;
        }
        .title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 10px;
          p:first-of-type {
            font-size: 3.12rem;
            font-weight: 700;
            max-width: 100%;
            margin: 0;
          }
          p:last-of-type {
            font-size: 22px;
            font-weight: 700;
            color: #000;
            margin: 0;
          }
        }
        .price {
          .prod_discount_price {
            display: flex;
            align-items: baseline;
            gap: 10px;
            .old_prod_price {
              font-size: 16px;
              font-weight: 500;
              color: red;
              text-decoration: line-through;
            }
            .prod_price {
              font-size: 22px;
              font-weight: 700;
              color: #000;
            }
          }
        }
        .lowest_price_note {
          font-size: 13px;
          font-weight: 400;
          color: #777;
          margin-top: 6px;
        }
      }
    }
    .gray__prod_wrapper {
      position: relative;
      z-index: 2;
      margin: 20px;
      margin-top: 0;
      border-radius: 30px;
      overflow: hidden;
    }
    
    .info__wrapper {
      display: flex;
      flex-direction: column;
      padding: 20px;
      z-index: 2;
      position: relative;
      p {
        font-size: 20px;
        font-weight: 400;
        margin: 0;
        text-align: left;
      }
      textarea {
        // border: 1px solid var(--principal);
        font-size: 1.37rem;
        font-weight: 500;
        border: 0;
        border-radius: 20px;
        height: 110px;
        width: 100%;
        resize: vertical;
        padding: 20px;
        &::placeholder {
          font-size: 1.37rem;
          font-weight: 500;
          opacity: 0.5;
          color: #000;
        }
      }
    }
    .other_info {
      padding-left: 20px;
      padding-right: 20px;
      padding-top: 0px;
      .info {
        // border: 1px solid var(--principal);
        border: 0;
        border-radius: 20px;
        text-align: left;
        padding: 20px;
        margin-bottom: 20px;
        position: relative;
        background: #fff;
        h2 {
          font-size: 1.62rem;
          font-weight: 500;
          margin: 0;
          color: #000;
          padding-right: 25px;
        }
        .description {
          margin-top: 20px;
          font-size: 1.25rem;
          font-weight: 500;
          overflow-wrap: break-word;
          p {
            line-height: 1.6;
          }
        }
        .other_info_ico {
          svg {
            position: absolute;
            width: 10px;
            right: 20px;
            top: 25px;
            color: #000;
            transition: 0.5s;
            &.closed {
              transform: rotate(45deg);
              transition: 0.5s;
            }
          }
        }
      }
    }
    .footer {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      z-index: 2;
      height: 180px;
      background: #F5F5F5;
      .footer__quantity {
        width: 35%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: #fff;
        border-radius: 50px;
        border: 1px solid #DBDBDB;
        span {
          color: #000;
          font-size: 2.75rem;
          font-weight: 500;
          margin-left: 20px;
          margin-right: 20px;
          min-width: 30px;
        }
        button {
          font-size: 2.75rem;
          font-weight: 400;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000;
          background: transparent;
          border: 0;
          border-radius: 10px;
          width: 150px;
          height: 100%;
          padding: 0;
          border-radius: 20px;
          overflow: hidden;
          &:before {
            content: "";
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            background: #fff;
            opacity: 0.5;
            z-index: -1;
          }
          &:disabled {
            color: #000;
            &:before {
              content: none;
            }
          }
          // &:hover {
          //   border: 2px solid var(--principal);
          //   color: var(--principal);
          // }
        }
      }
      .footer__right {
        width: calc(100% - 20px);
        max-width: 350px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: end;
      }
      .footer__price {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 10px 30px;
        border-radius: 10px;
        box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
        span {
          display: block;
          &:first-of-type {
            font-size: 15px;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .footer__addToCart {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        button {
          font-size: 16px;
          font-weight: 500;
          color: var(--addBtnColorInv);
          border: 0px;
          border-radius: 50px;
          background: var(--addBtnColor);
          padding: 20px;

          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          span {
            margin-left: 5px;
          }
          svg {
            fill: var(--addBtnColorInv);
            stroke: var(--addBtnColorInv);
            width: 40px;
            height: 40px;
            margin-right: 15px;
          }
          &:disabled {
              opacity: 0.5;
          }
        }
      }
    }
  }
  .addToCart {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    button {
      width: 100%;
    }
    .addToCart__left {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      width: 30%;
      height: 100%;
      img {

      }
    }
    .addToCart__right {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .total {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        padding: 15px 40px;
        border-radius: 20px;
        span {
          display: block;
          &:first-of-type {
            font-size: 1.62rem;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.75rem;
            font-weight: 700;
          }
        }
      }
      .orderNowDesc {
        margin-top: 10px;
        font-weight: bold;
      }
      .orderNow {
        max-width: 350px;
        width: calc(100% - 20px) !important;
        height: 56px;
        color: var(--addBtnColorInv);
        font-weight: 500;
        font-size: 20px;
        border: 0px;
        border-radius: 50px;
        background: var(--addBtnColor);
        &:disabled {
          opacity: 0.5;
        }
      }
    }
    .total {
      span {
        font-size: 28px;
        font-weight: 500;
        color: var(--principal);
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
  }
  .couponBtn,
  .orderNow {
    font-size: 20px;
    background: var(--principal);
    color: #fff;
    padding: 10px 40px;
    border: 0;
    border-radius: 50px;
    // @media screen and (max-width: 1800px) {
    //   font-size: 16px;
    //   padding: 18px 38px;
    // }
    // @media screen and (max-width: 1300px) {
    //   font-size: 16px;
    //   padding: 10px 20px;
    // }
    &:disabled,
    &[disabled] {
      opacity: 0.5;
    }
  }
  .couponBtn {
    background: #F3A223;
  }
  .toolbar {
    width: 100%;
    height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // -webkit-box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    // -moz-box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    // box-shadow: 0px 0px 30px -10px rgba(0,0,0,0.3);
    background: var(--principal);
    z-index: 3;
    padding: 20px 20px;
    .top__toolbar {
      display: flex;
      align-items: stretch;
      justify-content: space-between;
      width: 100%;
      height: 100%;
    }
    // .bottom__toolbar {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   width: 100%;
    //   height: 20px;
    //   .logo__toolbar {
    //     height: 20px;
    //     img {
    //       width: 100%;
    //       height: 100%;
    //     }
    //   }
    // }
    .left__toolbar {
      width: calc(25% - 20px);
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .cart_btn {
        position: relative;
        padding: 20px 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: auto;
        min-width: 150px;
        height: 100%;
        &::before {
          content: "";
          background: var(--principal);
          filter: brightness(0.9);
          border-radius: 20px;
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
          z-index: -1;
        }
        span {
          color: #fff;
          font-size: 16px;
          font-weight: 700;
        }
      }
      .cart__toolbar {
        position: relative;
        width: 70px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        svg {
          width: 100%;
          fill: var(--principal)
        }
        .roundNr {
          position: absolute;
          top: -10px;
          right: -5px;
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
          font-weight: bold;
          border-radius: 100%;
          font-size: 1.3rem;

          &.bounce {
            -webkit-animation-name: bounce;
            animation-name: bounce;
            -webkit-animation-duration: 2s;
            animation-duration: 2s;
            -webkit-animation-fill-mode: both;
            animation-fill-mode: both;
          }
        }
      }
      // .bar__toolbar {
      //   display: flex;
      //   align-items: center;
      //   justify-content: center;
      //   height: 70%;
      //   width: 10px;
      //   margin-left: 20px;
      //   margin-right: 20px;
      //   .bar {
      //     height: 100%;
      //     width: 1px;
      //     // background: var(--secundar);
      //     background: #909090;
      //   }
      // }
      .total__toolbar {
        font-size: 20px;
        font-weight: 600;
        button {
          background: #F3A223;
        }
      }
    }
    .right__toolbar {
      width: 75%;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: end;
      .right__toolbar__tot {
        height: 100%;
        background: #fff;
        color: var(--principal);
        margin-right: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        span {
          display: block;
          &:first-of-type {
            font-size: 1.62rem;
            font-weight: 500;
          }
          &:last-of-type {
            font-size: 2.5rem;
            font-weight: 700;
          }
        }
      }
      .right__toolbar__pay {
        width: 290px;
        height: 100%;
        background: var(--addBtnColor);
        font-size: 1.87rem;
        font-weight: 700;
        color: var(--addBtnColorInv);
        &:disabled {
          opacity: 0.5;
        }
      }
    }
  }
  .topBar {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px;
    background: var(--principal);
    color: var(--addBtnColorInv);
    z-index: 22;
    position: relative;
    .backButton {
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .waiter {
      width: 60px;
      height: 100%;
      position: absolute;
      right: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .search {
      width: 60px;
      height: 100%;
      position: absolute;
      right: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        max-width: 30px;
      }
    }
    .cart {
      width: 60px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      .roundNr {
        background: black;
        color: #fff;
        border-radius: 50px;
        width: 18px;
        height: 18px;
        font-weight: 800;
        line-height: 18px;
        position: absolute;
        top: 10px;
        right: 8px;
      }
    }
    .title {
      color: #fff;
      font-size: 20px;
    }
    .topBar__left {
      display: flex;
      align-items: center;
      justify-content: flex-start;
    }
    .topBar__back {
      margin-right: 20px;
      svg {
        fill: var(--principal);
        width: 40px;
      }
    }
    .topBar__title {
      font-size: 3.12rem;
      font-weight: 300;
    }
  }
  .lang_btn {
    position: relative;
    width: 40px;
    height: 40px;
    a,
    img {
      width: 100%;
      height: 100%;
    }

    .listOfLang {
      opacity: 0;
      position: absolute;
      top: 0;
      right: 100%;
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s;
      a {
        position: absolute;
        top: 0;
        right: -50px;
        width: 40px;
        height: 40px;
        transform: scale(0);
        transform-origin: center;
        margin-right: 10px;
        transition: 0.3s;
      }
    }
    >a>img {
      transform: scale(1);
      transition: 0.5s;
    }
    &.open {
      >a>img {
        transform: scale(1.2);
        transition: 0.5s;
      }
      .listOfLang {
        opacity: 1;
        transition: 0.5s;
        a {
          position: relative;
          right: 0;
          transform: scale(1);
          transform-origin: center;
          transition: 0.5s;
        }
      }
    }
  }
  .orderspos {
    display: flex;
    height: calc(100% - 640px);  // -banner - footer + 40margin
    flex-direction: column;
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    margin-top: -40px;
    // padding-top: 20px;
    z-index: 2;
    background: #F5F5F5;
    &.noBanner {
      margin-top: 0px;
      height: calc(100% - 180px);  // -Footer
      &.noToolbar {
        height: calc(100%);
      }
    }
    &.noToolbar {
      height: calc(100% - 460px); // -banner+40margin
    }
  }

  .cartDetail {
    height: 100%;
    // height: calc(100% - 220px);
    // min-height: calc(80vh - 480px);
    min-height: calc(100vh - 280px);
    .tipsBox {
      border-top: 1px solid #DFDFDF;
      .tipsInputsTitle {
        font-size: 15px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        text-decoration: underline;
        // span {
        //   text-decoration: underline;
        // }
      }
      .tipsValue {
        font-size: 15px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        span {
          text-decoration: underline;
        }
      }
      .custom-tip-input {
        margin-bottom: 10px;
      }
      .tipsInputs {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: auto;
        .col {
            background: #fff;
            padding: 4px 5px;
            border-radius: 50px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 90px;
            border: 1px solid #DFDFDF;
            font-size: 16px;
            font-weight: 600;
            margin: 5px;
            img {
              max-width: 27px;
            }
        }
        .col.selected {
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
        }
        .col.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
        }
      }
      .tipsInputs.disabled {
          opacity: 0.3;
          user-select: none;
          pointer-events: none;
      }
      .custom-tip-input {
        input {
          border-radius: 50px;
          font-size: 14px;
          height: 37px;
          padding: 5px 20px;
          margin: 5px 0px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 37px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
      .custom-tip-input.disabled {
        opacity: 0.3;
        user-select: none;
        pointer-events: none;
      }
      .tips {
        font-size: 16px;
        background: transparent;
        color: green;
        text-decoration: underline;
        padding-top: 0px;
      }
    }
    .commentClientsBox {
       border-top: 1px solid #DFDFDF;
      .commentClientsTitle {
        font-size: 15px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        color: #000;
        span {
          text-decoration: underline;
        }
      }
      .inputComment {
        textarea {
          font-size: 1.37rem;
          font-weight: 500;
          border: 0;
          border-radius: 20px;
          height: 110px;
          resize: vertical;
          padding: 20px;
          margin: 0 20px;
          width: calc(100% - 40px);
          margin-bottom: 20px;
        }
      }
    }
    .couponBox {
      .couponInputsTitle {
        font-size: 16px;
        font-weight: 600;
        text-align: left;
        margin: 0 20px;
        padding-top: 10px;
        padding-bottom: 10px;
        color: green;
        span {
          text-decoration: underline;
        }
      }
      .inputCoupn {
        input {
          font-size: 14px;
          height: 43px;
          padding: 5px 20px;
          margin: 5px 0px;
          margin-bottom: 10px;
          border-radius: 50px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
        }
        button {
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          height: 43px;
          padding: 10px 20px;
          font-size: 15px;
          font-weight: 500;
          width: 95px;
        }
      }
    }
    .totalCart {
      display: flex;
      justify-content: center;
      flex-direction: column;
      width: calc(100% - 40px);
      padding-left: 30px;
      font-size: 16px;
      font-weight: 600;
      border-top: 1px solid #DFDFDF;
      border-bottom: 1px solid #DFDFDF;
      margin: 0 20px;
      padding: 18px 0px;
      .totalsOptions {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        span {
          font-weight: 500;
        }
      }
    }
    .orderTotal {
      display: flex;
      justify-content: space-between;
      span {
        font-weight: 600;
        font-size: 18px;
      }
    }
  }
  .pre__footer {
    width: 100%;
    // height: 300px;
    height: auto;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    padding: 20px;
    .pre__footer__l {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      width: calc(50% - 5px);
      button {
        max-width: 300px;
      }
    }
    .pre__footer__r {
      // display: flex;
      // flex-direction: column;
      // align-items: flex-end;
      // justify-content: center;
      display: block;
      text-align: right;

      border-radius: 20px;
      width: calc(50% - 5px);
      .pre__footer__r__colorbox {
        // background: #F9F9F9;
      }
    }
    .totalsOptions {
      margin: 20px;
      span {
        font-size: 1.87rem;
        font-weight: 400;
        &:first-of-type {
          margin-right: 20px;
        }
        &:last-of-type {
          font-weight: 600;
        }
      }
    }
    .tips {
      background: transparent !important;
      color: #0f6015 !important;
      text-decoration: underline !important;
      font-weight: 500 !important;
    }
    .tips,
    .couponBtn {
      font-size: 16px;
      font-weight: 600;
      padding: 20px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #000;
      background: transparent;
      text-decoration: underline;
      margin-left: auto;
      border: none;
      font-weight: 300;
      margin-top: 20px;
      border-radius: 50px;
    }
    .tips {
      padding: 10px;
      margin-top: 5px;
      background: var(--principal);
      color: #fff;
    }
    .emptyCart {
      font-size: 1.62rem;
      font-weight: 500;
      padding: 20px 40px;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ff0000;
      background: #fff;
      border: 1px solid #ff0000;
      svg {
        fill: #ff0000;
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }
  }
  .footer {
    height: 180px;
    padding: 20px;
    background: #f5f5f5;
  }
  .cartDetail__head {
    height: 150px;
  }
  .products {
    height: calc(100% - 150px);
    max-height: calc(100vh - 150px);
    overflow: auto;
  }
  .products::-webkit-scrollbar {
      width: 5px;
  }
  .products::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 0px solid transparent;
      background-clip: content-box;
      background-color: var(--principal);
  }
  .products::-webkit-scrollbar-track {
      background-color: #e4e4e4;
      border-radius: 100px;
  }

  .cartDetail_wrapper,
  .productList_wrapper {
    width: 100%;
    // height: calc(100% - 40px);
    height: 100%;
    position: relative;
    display: flex;
    &.disabled {
      opacity: 0.3;
      user-select: none;
      pointer-events: none;
    }
  }
  // .noBanner {
  //   .cartDetail_wrapper,
  //   .productList_wrapper {
  //     height: calc(100% - 80px);
  //   }
  // }
  .productList_wrapper {
    border-radius: 20px;
    padding-bottom: 0;
    .productList_wrapper_left {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding-top: 10px;
      padding-bottom: 10px;
      padding-left: 0;
      padding-right: 0;
      background: #f5f5f5;
      border-top-left-radius: 50px;
      // .productList_filter {
      //   height: 60px;
      //   min-height: 60px;
      //   display: flex;
      //   align-items: center;
      //   justify-content: flex-start;
      //   padding-left: 10px;
      //   h3 {
      //     margin: 0;
      //   }
      // }
    }
    .productList_wrapper_right {
      width: 75%;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      padding-left: 10px;
      padding-right: 10px;
      // padding-bottom: 10px;
      // box-shadow: inset 10px -10px 30px -30px rgb(0 0 0 / 30%);
    }
    .search_topBar {
      height: 45px;
      margin-top: 10px;
      margin-bottom: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      .search_wrapper {
        width: calc(100% - 20px);
        display: flex;
        flex-direction: row;
      }
      .searchBtn {
        display: flex;
        align-items: center;
        justify-content: center;
        pointer-events: all;
        cursor: pointer;
        z-index: 2;
        margin-top: 5px;
        margin-left: 1px;
        .circle {
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: #ECECEC;
          margin-bottom: 10px;
          // &:hover {
          //   background: var(--principal);
          //   svg {
          //     color: #fff;
          //     fill: #fff;
          //     * {
          //       stroke: #fff;
          //     }
          //   }
          // }
          &.used {
            background: var(--principal);
            svg * {
              stroke: #fff;
              color: #fff;
              fill: #fff;
            }
          }
          svg {
            margin: 0;
            width: 20px;
            color: #777777;
            fill: #777777;
            * {
              stroke: #777777;
            }
          }
        }
        // svg {
        //   margin-bottom: 10px;
        //   @media screen and (max-width: 1800px) {
        //     width: 50px;
        //     height: 50px;
        //   }
        //   @media screen and (max-width: 1300px) {
        //     width: 40px;
        //     height: 40px;
        //   }
        // }
      }
      .filter__search {
        // width: calc(100% - 20px);
        width: 100%;
        display: none;
        align-items: center;
        justify-content: flex-start;
        // background: #fff;
        // margin-left: 20px;
        &.showw {
          display: flex;
        }
        .search {
          position: relative;
          width: 100%;
          margin-top: 0;
          margin-bottom: 0;
          display: flex;
          button {
            padding: 0px;
            width: 140px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            font-size: 16px;
            box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
          }
          input {
            width: 100%;
            padding-left: 35px;
            padding-right: 35px;
            border-radius: 28px;
            border: 1px solid #EEEEEE;
            background: transparent;
            background: #fff;
            height: 45px;
            font-size: 16px;
            font-weight: 500;
            border-top-right-radius: 0px;
            border-bottom-right-radius: 0px;
            box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
            &::placeholder {
              color: rgb(0 0 0 / 37%);
              font-size: 16px;
              font-weight: 500;
              opacity: 1; /* Firefox */
            }
          }
          .icosearch {
            height: 20px;
            position: absolute;
            left: 15px;
            top: calc(50% - 11px);
            svg {
              width: auto;
              height: 100%;
              fill: var(--principal);
              stroke: var(--principal);
            }
          }
          .closeSearch {
            height: 20px;
            position: absolute;
            right: 10px;
            top: calc(50% - 10px);
            opacity: 0;
            transition: 0.5s;
            display: flex;
            align-items: center;
            &.show {
              opacity: 1;
              transition: 0.5s;
            }
            svg {
              width: auto;
              height: 70%;
              fill: var(--principal);
            }
          }
        }
      }
    }
  }
  .zoom {
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
    svg {
      @media screen and (max-width: 1800px) {
        width: 48px;
        height: 50px;
      }
      @media screen and (max-width: 1300px) {
        width: 38px;
        height: 40px;
      }
    }
  }
  .productList::-webkit-scrollbar {
      width: 0px;
      // width: 5px;
  }
  .productList::-webkit-scrollbar-thumb {
      border-radius: 100px;
      border: 0px solid transparent;
      background-clip: content-box;
      background-color: var(--secundar);
  }
  .productList::-webkit-scrollbar-track {
      background-color: #f1f1f1;
      border-radius: 100px;
  }
  .productList__wrapper {
    position: relative;
    display: flex;
    width: 100%;
    height: calc(100% - 170px);
    // margin-top: 10px;
    padding-top: 20px;
    padding-bottom: 20px;
    &.activeTop {
      &::before {
        opacity: 1;
        transition: 0.7s;
      }
    }
    &.activeBottom {
      &::after {
        opacity: 1;
        transition: 0.7s;
      }
    }
    &::after,
    &::before {
      // content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 50px;
      // filter: blur(30px);
      // backdrop-filter: opacity(0.5);
      /* backdrop-filter: blur(1px); */
      background: transparent;
      opacity: 0;
      transition: 0.7s;
      pointer-events: none;
      z-index: 3;
    }
    &::after {
      bottom: -1px;
      // background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      background: linear-gradient(0deg, rgb(241 241 241) 0%, rgba(0, 212, 255, 0) 100%);
    }
    &::before {
      top: -1px;
      // background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      background: linear-gradient(180deg, rgb(241 241 241) 0, rgba(0, 212, 255, 0) 100%);
    }
  }
  .productList {
    position: relative;
    width: 100%;
    height: 100%;
    // height: calc(100% - 50px); // +10px For Custom Scrool
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-top: 0px;
    padding-bottom: 0px;
    // padding-bottom: 30px; // for swipeUpForMore
    // margin-right: 10px; // For Custom Scrool
    .no-products-found {
      font-size: 16px;
      font-weight: 600;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin-top: 20px;
    }
    .productcat {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      overflow: hidden;
      >span {
        width: 100%;
        border-bottom: 1px solid #000;
        padding-top: 20px;
        padding-bottom: 5px;
        padding-left: 10px;
        margin-bottom: 10px;
      }
    }
    .product {
      width: calc(20% - 20px);
      margin-left: 10px;
      margin-right: 10px;
      margin-bottom: 20px;
      position: relative;
      height: auto;
      display: flex;
      align-items: center;
      flex-direction: column;
      text-align: center;
      justify-content: space-between;

      background: transparent;
      border-radius: 10px;
      @media screen and (max-width: 1800px) {
        width: calc(33.33% - 20px);
      }
      @media screen and (max-width: 1400px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 900px) {
        width: calc(50% - 20px);
      }
      @media screen and (max-width: 500px) {
        width: calc(100% - 20px);
      }
      transition: 0s;
      overflow: hidden;
      position: relative;
      &.pressed{
        // transform: translate(0px,0px) scale(0.7);
        // -webkit-transform: translate(0px,0px) scale(0.7);
        // transition: 0.5s !important;
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          width: 50px;
          height: 50px;
          -webkit-animation: effect-animation 1s;
          background: #fff;
          opacity: 0;
          z-index: 3;
        }
      }
      .product_img_title {
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        padding: 14px;
        border-radius: 20px;
        background: #fff;
      }
      .productImage__wrapper {
        position: relative;
        width: 100%;
        height: 350px;
        @media screen and (max-width: 500px) {
          height: 200px;
        }
        // margin-bottom: 10px;
      }
      .productImage {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 10px;
        user-select: none;
        position: relative;
        z-index: 2;
        margin: 0;
      }
      // .rectangle {
      //   border-radius: 20px;
      //   background: var(--secundar);
      //   opacity: .5;
      //   width: 100%;
      //   height: 55%;
      //   position: absolute;
      //   left: 0;
      //   bottom: 0;
      //   z-index: 1;
      //   display: none;
      // }
      img {
        border-radius: 20px;
        margin-bottom: 10px;
      }
      p {
        text-overflow: ellipsis;
        overflow: hidden;
        margin: 0;
        &.prod_title {
          font-size: 16px;
          font-weight: 700;
          color: #000;
          width: 100%;
          // margin-top: -20px;
          margin-top: 20px;
          margin-bottom: 20px;
          // padding: 2px 10px;
          // background: #fff;
          // z-index: 2;
          // border-top-right-radius: 20px;
          // border-top-left-radius: 20px;
          // border-radius: 20px;
          // border: 1px solid var(--principal);
        }
        &.discount_badge {
          position: absolute;
          top: 0px;
          right: 7px;
          transform: rotate(-45deg);
          font-size: 12px;
          font-weight: 600;
          color: #fff;
          width: 122px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 3;
          &:before {
            content: "";
            position: absolute;
            right: 7px;
            top: 0px;
            width: 100%;
            height: 20px;
            background: red;
            z-index: -1;
          }
        }
        &.old_prod_price {
          font-size: 1.5rem;
          font-weight: 500;
          position: relative;
          color: red;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            top: 50%;
            width: 100%;
            height: 1px;
            background: red;
          }
        }
        &.prod_price {
          font-size: 16px;
          font-weight: 600;
          padding: 5px 10px;
          border-radius: 5px;
          margin-bottom: 20px;
          color: #000;
          // position: absolute;
          // top: 10px;
          // right: 10px;
          // z-index: 2;
          // &:before {
          //   content: "";
          //   background: var(--principal);
          //   position: absolute;
          //   left: 0;
          //   top: 0;
          //   width: 100%;
          //   height: 100%;
          //   z-index: -1;
          //   opacity: 0.7;
          // }
        }
      }
    }
  }
  .filter {
    width: 100%;
    // height: calc(100% - 60px);
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    padding-left: 0;
    .settings {
      position: absolute;
      left: 2px;
      bottom: 2px;
      width: 50px;
      height: 50px;
      z-index: 999;
      padding: 30px;
      padding-left: 2px;
      padding-bottom: 2px;
    }
    .logo_f {
      width: 100%;
      height: 170px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
      border-bottom: 1px solid #D4D4D4;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .filter__bar {
      width: 100%;
      height: calc(100% - 170px);
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      position: relative;
      &.activeTop {
        &::before {
          opacity: 1;
          transition: 0.7s;
        }
      }
      &.activeBottom {
        &::after {
          opacity: 1;
          transition: 0.7s;
        }
      }
      &::after,
      &::before {
        content: "";
        position: absolute;
        left: 0;
        width: 100%;
        height: 50px;
        // filter: blur(30px);
        // backdrop-filter: opacity(0.5);
        /* backdrop-filter: blur(1px); */
        background: transparent;
        opacity: 0;
        transition: 0.7s;
        pointer-events: none;
      }
      &::after {
        bottom: 0;
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      }
      &::before {
        top: 0;
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(0,212,255,0) 100%);
      }
      a {
        display: flex;
        align-items: stretch;
        flex-direction: row;
        justify-content: space-between;
        margin-bottom: 10px;
        width: 100%;
        border-radius: 10px;
        min-height: auto;
        padding: 20px 5px;
        box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
        &.selected {
          background: var(--principal);
          p {
            color: #fff;
          }
        }
      }
      .cat_photo {
        width: 80px;
        height: 80px;
        background-position: center;
        background-size: cover;
        background-color: transparent;
        background-repeat: no-repeat;
        border-radius: 100%;
      }
      p {
        text-overflow: ellipsis;
        overflow: hidden;
        height: auto;
        width: 60%;
        padding: 8px;
        padding-bottom: 0;
        margin: 0;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        color: #000;
        font-size: 1.37rem;
        font-weight: 700;
        // @media screen and (max-width: 1400px) {
        //   padding: 8px 10px;
        //   font-size: 12px;
        // }
        // @media screen and (max-width: 1300px) {
        //   padding: 5px 8px;
        // }
      }
      .filter__cat {
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        height: 100%;
        width: 100%;
        overflow: auto;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 20px;
        .topGroup {
          position: relative;
          border-radius: 20px;
          display: flex;
          flex-direction: column;
          width: 100%;
          &.active {
            .childs {
              height: 100%;
            }
            a {
              margin-bottom: 10px;
            }
          }
          &.active::after {
            content: "";
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: var(--principal);
            opacity: 0.5;
            pointer-events: none;
            border-radius: 20px;
            z-index: 1;
          }
        }
        a {
          position: relative;
          z-index: 2;
          margin: 0;
        }
        .childs {
          position: relative;
          z-index: 2;
          margin-left: 15px;
          width: calc(100% - 30px);
          height: 0;
          overflow: hidden;
          a {
            padding: 5px;
          }
        }
      }
      .filter__cat::-webkit-scrollbar {
          width: 0px; // Vertical
          height: 0px; // Horizontal
          // width: 5px;
      }
      .filter__cat::-webkit-scrollbar-thumb {
          border-radius: 100px;
          border: 0px solid transparent;
          background-clip: content-box;
          background-color: var(--secundar);
      }
      .filter__cat::-webkit-scrollbar-track {
          background-color: #f1f1f1;
          border-radius: 100px;
      }
    }
  }
  .show-loader {
    position: absolute;
    position: sticky;
    display: inline-block;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 3;
    backdrop-filter: blur(3px);

    .el-loading-spinner{
      z-index: 2001;
    }
    &:after{
      content: '';
      display: inline-block;
      position: absolute;
      width: calc(100% - 20px);
      margin: auto;
      top:0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(255,255,255,0.5);
      z-index: 2000;
      border-radius: 30px;
      margin: 0 10px;
    }
  }
  .el-loading-spinner {
    z-index: 2001;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    svg {
      width: 30%;
      height: 30%;
      fill: var(--principal);
    }
  }

  .hide-loader{
    .el-loading-spinner{
      display: none;
    }
  }

  // Overlay de asteptare Viva (plata cu cardul pe dispozitiv).
  .vivaWaiting {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100000;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.55);
    backdrop-filter: blur(3px);
    padding: 20px;

    &__box {
      background: #fff;
      border-radius: 24px;
      padding: 32px 28px;
      max-width: 340px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
    }

    &__spinner {
      width: 72px;
      height: 72px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;

      svg {
        width: 100%;
        height: 100%;
        fill: var(--principal);
      }
    }

    &__text {
      font-size: 18px;
      font-weight: 600;
      line-height: 1.35;
      color: #222;
      margin: 0;
    }

    &__actions {
      margin-top: 24px;
      display: flex;
      flex-direction: column;
      gap: 12px;
      width: 100%;
    }

    &__retry,
    &__cancel {
      border: none;
      outline: none;
      cursor: pointer;
      font-size: 16px;
      font-weight: 600;
      padding: 14px 32px;
      border-radius: 14px;
      transition: opacity 0.2s ease;
      width: 100%;

      &:active {
        opacity: 0.8;
      }
    }

    &__retry {
      background: var(--principal);
      color: var(--white);
    }

    &__cancel {
      background: transparent;
      color: #c0392b;
      border: 1px solid #c0392b;
    }
  }
  .in-processing {
    text-align: end;
    color: #f39e1a;
    p {
      font-size: 12px;
      font-weight: 500;
      color: #f39e1a;
    }
  }
  .in-prepared {
    text-align: end;
    color: #674bd2;
    p {
      font-size: 12px;
      font-weight: 500;
      color: #674bd2;
    }
  }
  .cartModal {
    .cartDetail {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .cart__wrapper {
      background: #F5F5F5;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
    }
    .cartDetail__head {
      height: 150px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .cartTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-top: 5px;
        p {
          font-size: 3.12rem;
          font-weight: 700;
          margin-bottom: 0px;
          margin-top: 10px;
          text-transform: uppercase;
        }
      }
      .packing_method {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        margin-bottom: 20px;
        span {
          font-size: 1.37rem;
          font-weight: 400;
          color: #000;
        }
      }
    }
    .no_products_in_cart {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      p {
        font-size: 24px;
        font-weight: 600;
        margin-top: 0;
        margin-bottom: 50px;
      }
      button {
        background: var(--principal);
        margin-top: 50px;
      }
      .middle {
        width: 40vw;
        height: 40vw;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 50px;
        &:after {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 100%;
          height: 100%;
          background: var(--principal);
          border-radius: 100%;
          z-index: 1;
          opacity: 30%;
        }
        &:before {
          content: "";
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
          height: 80%;
          background: var(--principal);
          border-radius: 100%;
          z-index: 2;
          opacity: 80%;
        }
        svg {
          width: 50%;
          height: 50%;
          fill: #fff;
          position: relative;
          z-index: 3;
        }
      }
    }
    .products {
      padding: 10px;
      .product {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        border-radius: 0px;
        padding: 20px;
        margin-bottom: 0px;
        .product_details_wrapper {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          .col-image {
            width: 55px;
            margin-right: 10px;
          }
          .col-info {
            width: 80%
          }
        }
        .product__photo {
          width: 20%;
          min-height: 105px;
          max-height: 250px;
          border-radius: 20px;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          margin-right: 10px;
        }
        .description {
          width: 40%;
        }
        .product_details {
          width: 40%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: space-around;
        }
        .product__name {
          font-size: 20px;
          font-weight: 600;
          display: block;
          text-align: left;
        }
        .product__is_bonus,
        .product__additional_info,
        .product__extra {
          display: block;
          text-align: left;
          font-size: 14px;
          margin-top: 10px;
        }
        .product_price {
          font-size: 2.25rem;
          font-weight: 700;
          color: #000;
          min-width: 70px;
          text-align: right !important;
        }
        .quantity {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-top: 0;
          margin-bottom: 0;
          background: #fff;
          border-radius: 50px;
          border: 1px solid #DBDBDB;
          svg {
            width: 18px;
            height: 18px;
            fill: red;
          }
          span {
            color: #000;
            font-size: 1.56rem;
            font-weight: 700;
            margin-left: 10px;
            margin-right: 10px;
            min-width: 20px;
          }
          button {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #000;
            background: transparent;
            border: 0;
            // border-radius: 10px;
            width: 40px;
            height: 42px;
            font-size: 25px;
            font-weight: 500;
            padding: 0;
            &:disabled {
              opacity: 0.2;
              // color: var(--secundar);
              // border-color: var(--secundar);
            }
            // &:hover {
            //   border: 2px solid var(--principal);
            //   color: var(--principal);
            // }
          }
        }
        .product_right {
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          margin-top: 20px;
          svg {
            // fill: #fff;
            width: 25px;
            height: auto;
            margin-right: 5px;
          }
          button {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 15px;
          }
          .product__modify {
            font-size: 1.50rem;
            font-weight: 500;
            background: #ECEBEB;
            color: #000;
            border-radius: 10px;
          }
          .product__delete {
            font-size: 1.50rem;
            font-weight: 500;
            background: #ECEBEB;
            color: #000;
            border-radius: 10px;
          }
        }
      }
    }
  }
  .paymentModal {
    .din,
    .take {
      border: 1px solid var(--secundar);
      box-shadow: none;
    }
    .top__payment {
      width: 100%;
      height: 30%;
      background: var(--secundar);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 10%;
      .model {
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20%;
          height: auto;
          margin-bottom: 3.12rem;
        }
      }
      // img {
      //   max-width: 300px;
      //   max-height: 300px;
      // }
      h2 {
        font-size: 28px;
        font-weight: 400;
      }
    }
    .backShopping {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 180px;
      padding: 20px;
      button {
        background: transparent;
        color: var(--addBtnColorInv);
        font-size: 1.87rem;
        font-weight: 700;
        background: var(--addBtnColor);
        border-radius: 20px;
        padding: 30px 50px;
        height: 100%;
      }
    }
  }
  .p9Modal {
    .iframeModal__wrapper {
      height: 100%;
    }
    .settings_buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      // background: #fff;
      background: linear-gradient(90deg, rgba(194,159,131,1) 0%, rgba(124,83,62,1) 100%);
      color: #fff;
      padding: 20px;
      img {
        max-width: 70%;
        margin-bottom: 30px;
      }
      h2 {
        font-weight: 400;
        letter-spacing: 1px;
      }
      .settings_buttons_btn2,
      .settings_buttons_btn1 {
        background: #fff;
        color: #000;
        padding: 10px 30px;
        margin-top: 30px;
        font-weight: 400;
        letter-spacing: 1px;
      }
      .settings_buttons_btn2 {
        background: #000;
        color: #fff;
      }
    }
  }
  .settingsModal {
    .settings_buttons {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      padding-top: 100px;
      font-size: 5rem;
      input {
        font-size: 5rem;
      }
      button {
        background: var(--principal);
        font-size: 5rem;
      }
    }
  }
  .payment__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: relative;
    padding-top: 50px;
    .selected {
      background: var(--addBtnColor) !important;
      color: var(--addBtnColorInv);
    }
    .disabled {
      opacity: 0.3;
      user-select: none;
      pointer-events: none;
    }
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -6.25rem;
      min-height: 500px;
    }
    .free,
    .pos,
    .din,
    .take {
      position: relative;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      padding: 0;
      background: #fff;
      border-radius: 30px;
      z-index: 2;
      -webkit-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      /* max-width: 22rem; */
      width: 50%;
      margin-bottom: 50px;
      min-height: 72px;
      &.disabled {
        user-select: none;
        opacity: 0.5;
      }
      svg {
        left: 10px;
        top: 10px;
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
        fill: var(--secundar);
      }
      img {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
      }
      &.loading {
        span {
          //display: none;
        }
        svg {
          left: calc(50% - 25px);
          transition: 2s;
        }
      } 
    }
    span {
      font-size: 3rem;
      font-weight: 600;
      margin-top: 0.62rem;
      text-align: left;
    }
  }
  .pack__wrapper__buttons {
    display: flex;
    align-items: stretch;
    justify-content: center;
    width: 100%;
    position: relative;
    padding-top: 50px;
    .pack__wrapper__buttons_bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 120%;
      margin-top: -1.25rem;
      svg {
        width: 100%;
        height: 100%;
        fill: var(--principal);
        filter: brightness(0.9);
      }
    }
    .free,
    .pos,
    .din,
    .take {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      padding: 6.250rem 3.125rem;
      background: #fff;
      border-radius: 30px;
      z-index: 2;
      -webkit-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      -moz-box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      box-shadow: 0px 0px 20px -10px rgba(0,0,0,0.75);
      max-width: 22rem;
      margin: 0 40px;
      min-height: 500px;
      svg {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
        fill: var(--iconsColor1);
        transition: 1s;
      }
      img {
        max-width: 15.62rem;
        max-height: 15.00rem;
        padding: 1.87rem;
      }
    }
    span {
      font-size: 3rem;
      font-weight: 600;
      margin-top: 0.62rem;
    }
  }
  .splashScreenModal {
    .pack__wrapper {
      width: 100%;
      height: 100%;
      overflow: hidden;
      position: relative;
      .lang_btn {
        position: absolute;
        right: 30px;
        top: 30px;
        width: 40px;
        height: 40px;
        z-index: 2;
        a,
        img {
          width: 100%;
          height: 100%;
        }

        .listOfLang {
          opacity: 0;
          position: absolute;
          top: 0;
          right: 100%;
          width: auto;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: 0.3s;
          a {
            position: absolute;
            top: 0;
            right: -50px;
            width: 40px;
            height: 40px;
            transform: scale(0);
            transform-origin: center;
            margin-right: 10px;
            transition: 0.3s;
          }
        }
        >a>img {
          transform: scale(1);
          transition: 0.5s;
        }
        &.open {
          >a>img {
            transform: scale(1.2);
            transition: 0.5s;
          }
          .listOfLang {
            opacity: 1;
            transition: 0.5s;
            a {
              position: relative;
              right: 0;
              transform: scale(1);
              transform-origin: center;
              transition: 0.5s;
            }
          }
        }
      }
      .splash_bg {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
      .bg_splash_wrapper {
        width: 100%;
        height: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-end;
      }
      .top__pack__wrapper {
        height: 35%;
        background: var(--secundar);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding-bottom: 10%;
        .model {
          background-position: center;
          background-size: cover;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20%;
            height: auto;
            margin-bottom: 3.12rem;
          }
        }
        // img {
        //   max-width: 300px;
        //   max-height: 300px;
        // }
        h2 {
          font-size: 28px;
          font-weight: 400;
        }
      }
      .round {
        width: 100%;
        height: 75%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding-top: 5%;
        .logo_t {
          position: absolute;
          left: 0;
          bottom: 5%;
          width: 100%;
        }
        .total {
          margin-top: 30px;
          margin-bottom: 50px;
          font-size: 24px;
          font-weight: 400;
          color: var(--principal);
          span:first-child  {
            margin-right: 10px;
          }
        }
        h2 {
          position: relative;
          color: #fff;
          font-size: 3rem;
          font-weight: 400;
          margin-bottom: 70px;
          z-index: 2;
        }
        .roundbg {
          width: 200%;
          height: 100%;
          background: var(--principal);
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0;
          border-top-right-radius: 50%;
          border-top-left-radius: 50%;
        }
      }
    }
    .splashScreen__wrapper {
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      &.hiden {
        opacity: 0;
        width: 0;
        height: 0;
      }
      &.defaultOne {
        .model {
          width: 100%;
          height: auto;
          position: absolute;
          left: 0;
          top: 15%;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: auto;
            height: auto;
            max-width: 200px;
            margin: auto;
          }
        }
        .text {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 20%;
          position: absolute;
          left: 0;
          bottom: 0;
          p {
            margin: 0;
            color: #fff;
            font-size: 3em;
            width: 50%;
          }
        }
      }
    }
  }
  button {
    background: var(--principal);
    border-radius: 20px;
    border: 0;
    padding: 15px 40px;
    color: #fff;
    font-weight: 600;
  }
  .complete__wrapper {
    height: 100%;
    .dialog {
      position: relative;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      width: 400px;
      height: 90px;
      font-size: 1.37rem;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto;
      margin-right: 15%;
      span {
        margin-bottom: 15px
      }
    }
    .top__pack__wrapper {
      width: 100%;
      height: 35%;
      background: var(--secundar);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding-bottom: 10%;
      .model {
        background-position: center;
        background-size: cover;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 20%;
          height: auto;
          margin-bottom: 3.12rem;
        }
      }
      h2 {
        font-size: 28px;
        font-weight: 400;
      }
      .pack__wrapper__buttons_bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 120%;
        margin-top: -4.25rem;
        min-height: 500px;
      }
      .round {
        width: 100%;
        height: 75%;
        position: absolute;
        left: 0;
        bottom: 0;
        padding-top: 5%;
        overflow: hidden;
        .logo_t {
          position: absolute;
          left: 0;
          bottom: 5%;
          width: 100%;
        }
        .total {
          margin-top: 30px;
          margin-bottom: 50px;
          font-size: 24px;
          font-weight: 400;
          color: var(--principal);
          span:first-child  {
            margin-right: 10px;
          }
        }
        h2 {
          position: relative;
          color: #fff;
          // font-family: 'Devitta';
          font-size: 7.31rem;
          font-weight: 400;
          z-index: 2;
          margin-top: -25px;
          margin-bottom: 120px;
        }
        .roundbg {
          width: 200%;
          height: 100%;
          background: var(--principal);
          position: absolute;
          left: 50%;
          transform: translate(-50%, 0);
          bottom: 0;
          border-top-right-radius: 50%;
          border-top-left-radius: 50%;
        }
      }
    }
    h2 {
      font-size: 30px;
      color: var(--principal);
      font-weight: 500;
      margin: 0;
      margin-top: 70px;
    }
    p {
      font-size: 26px;
      color: var(--principal);
      font-weight: 400;
      margin: 0;
    }
    .order_nr_wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .order_nr {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
        svg {
          position: relative;
        }
        .order_nr_txt {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          // padding-right: 30%;
        }
        span {
          font-size: 1.50rem;
          font-weight: 300;
          color: #000;
          &:last-of-type {
            font-size: 7.00rem;
            font-weight: 500;
            color: #000;
          }
        }
      }
    }
    .steps {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      max-width: 50%;
      position: relative;
      margin: auto;
      margin-top: 100px;
      .step {
        padding-bottom: 20px;
        padding-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        span {
          font-size: 2.18rem;
          font-weight: normal;
          color: #fff;
        }
        .step_round {
          font-size: 1.56rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 100%;
          background: var(--addBtnColor);
          color: var(--addBtnColorInv);
          width: 40px;
          height: 40px;
        }
      }
    }
    .back {
      position: relative;
      margin-top: 50px;
      button {
        background: var(--addBtnColor);
        font-size: 2rem;
        color: var(--addBtnColorInv);
      }
    }
  }
  .error_page {
    z-index: 99999; // in front of loading!!
    width: 100%; 
    height: 100%;
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20%;
    padding-left: 10px;
    padding-right: 10px;
  }

  .topBar.consultativeMenuBar,
  .topBar.consultativeDetailBar {
    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      max-width: calc(100% - 180px);
      white-space: nowrap;
      text-align: center;
    }
    .waiter {
      right: 0;
    }
  }
  .topBar.consultativeMenuBar .search {
    right: 60px;
  }
  .productModal.consultativeProductModal .productModal__wrapper,
  .optionModal.consultativeOptionModal .productModal__wrapper {
    height: 100%;
    max-height: 100%;
    margin-bottom: 0;
  }
  .productModal.consultativeProductModal .productModal__wrapper > .product {
    height: calc(100% - 60px);
    max-height: calc(100% - 60px);
    overflow-y: auto;
    overflow-x: hidden;
  }
  .optionModal.consultativeOptionModal .productModal__wrapper > .prod_white {
    height: calc(100% - 60px);
  }
</style>
